/* Frangipani runtime labels: keep each native feature lifecycle isolated below. */
(() => {
  const frRuntimeLocale = (document.documentElement.lang || 'pl').toLowerCase().split('-')[0];
  const frRuntimeMessages = {"choose_size":{"pl":"Wybierz rozmiar","en":"Choose a size","de":"Größe auswählen"},"choose_colour":{"pl":"Wybierz kolor","en":"Choose a colour","de":"Farbe auswählen"},"choose_finish":{"pl":"Wybierz wykończenie","en":"Choose a finish","de":"Ausführung auswählen"},"choosing_variant":{"pl":"Wybieranie wariantu…","en":"Selecting the variant…","de":"Variante wird ausgewählt…"},"confirm_choice":{"pl":"Potwierdź wybór","en":"Confirm your choice","de":"Auswahl bestätigen"},"variant_load_failed":{"pl":"Nie udało się wczytać dostępnych wariantów. Spróbuj ponownie.","en":"The available variants could not be loaded. Please try again.","de":"Die verfügbaren Varianten konnten nicht geladen werden. Bitte versuche es erneut."},"variant_unavailable_finish":{"pl":"Ten wariant nie jest dostępny. Wybierz inne wykończenie.","en":"This variant is unavailable. Choose another finish.","de":"Diese Variante ist nicht verfügbar. Wähle eine andere Ausführung."},"variant_cannot_choose":{"pl":"Nie można wybrać tego wariantu. Wybierz inne wykończenie.","en":"This variant cannot be selected. Choose another finish.","de":"Diese Variante kann nicht ausgewählt werden. Wähle eine andere Ausführung."},"edit":{"pl":"Zmień","en":"Change","de":"Ändern"},"loading_variants":{"pl":"Wczytywanie dostępnych wariantów…","en":"Loading available variants…","de":"Verfügbare Varianten werden geladen…"},"retry":{"pl":"Spróbuj ponownie","en":"Try again","de":"Erneut versuchen"},"height":{"pl":"Wysokość","en":"Height","de":"Höhe"},"width":{"pl":"Szerokość","en":"Width","de":"Breite"},"length":{"pl":"Długość","en":"Length","de":"Länge"},"depth":{"pl":"Głębokość","en":"Depth","de":"Tiefe"},"size":{"pl":"Rozmiar","en":"Size","de":"Größe"},"price":{"pl":"Cena","en":"Price","de":"Preis"},"dimensions_finish_note":{"pl":"Wymiary zależą od wykończenia. Dokładne wartości zobaczysz w kolejnym kroku.","en":"Dimensions depend on the finish. You will see the exact measurements in the next step.","de":"Die Maße hängen von der Ausführung ab. Die genauen Werte siehst du im nächsten Schritt."},"loading_selected_variant":{"pl":"Wczytywanie wybranego wariantu…","en":"Loading the selected variant…","de":"Ausgewählte Variante wird geladen…"},"variant_retry_choice":{"pl":"Nie udało się wczytać wariantu. Wybierz go ponownie, aby spróbować jeszcze raz.","en":"The variant could not be loaded. Select it again to retry.","de":"Die Variante konnte nicht geladen werden. Wähle sie erneut aus, um es noch einmal zu versuchen."},"add_to_cart":{"pl":"Dodaj do koszyka","en":"Add to cart","de":"In den Warenkorb"},"adding":{"pl":"Dodawanie…","en":"Adding…","de":"Wird hinzugefügt…"},"adding_to_cart":{"pl":"Dodawanie do koszyka","en":"Adding to cart","de":"Wird zum Warenkorb hinzugefügt"},"preorder":{"pl":"Przedsprzedaż","en":"Pre-order","de":"Vorbestellung"},"dispatch_after_arrival":{"pl":"Wysyłka po dostawie kolekcji","en":"Dispatch after the collection arrives","de":"Versand nach Eingang der Kollektion"},"shipping_information":{"pl":"Informacje o wysyłce","en":"Shipping information","de":"Versandinformationen"},"product_photos":{"pl":"Zdjęcia produktu","en":"Product images","de":"Produktbilder"},"product_gallery":{"pl":"Galeria zdjęć produktu","en":"Product image gallery","de":"Produktbildergalerie"},"preorder_shipping":{"pl":"Przedsprzedaż — zasady wysyłki","en":"Pre-order — shipping terms","de":"Vorbestellung — Versandbedingungen"},"outlet_product_information":{"pl":"Outlet — informacje o produkcie","en":"Outlet — product information","de":"Outlet — Produktinformationen"},"delivery":{"pl":"Dostawa","en":"Delivery","de":"Lieferung"},"showroom_availability":{"pl":"Przed wizytą potwierdź dostępność wybranego obiektu.","en":"Before visiting, confirm the availability of your chosen object.","de":"Bestätige vor deinem Besuch die Verfügbarkeit des ausgewählten Objekts."},"choose_option":{"pl":"Wybierz {{option}}","en":"Choose {{option}}","de":"{{option}} auswählen"},"price_from":{"pl":"od {{price}}","en":"from {{price}}","de":"ab {{price}}"},"close":{"pl":"Zamknij","en":"Close","de":"Schließen"},"step":{"pl":"Krok {{current}} z {{total}}","en":"Step {{current}} of {{total}}","de":"Schritt {{current}} von {{total}}"},"product_description":{"pl":"Opis produktu","en":"Product description","de":"Produktbeschreibung"},"media_position":{"pl":"Multimedia {{current}} z {{total}}","en":"Media {{current}} of {{total}}","de":"Medium {{current}} von {{total}}"},"show_media":{"pl":"Pokaż multimedia {{current}} z {{total}}","en":"Show media {{current}} of {{total}}","de":"Medium {{current}} von {{total}} anzeigen"},"preorder_details":{"pl":"Szczegóły przedsprzedaży","en":"Pre-order details","de":"Details zur Vorbestellung"},"footer.aria_label":{"pl":"Stopka Frangipani","en":"Frangipani footer","de":"Frangipani Fußzeile"},"footer.contact":{"pl":"Kontakt","en":"Contact","de":"Kontakt"},"footer.home_label":{"pl":"Frangipani — strona główna","en":"Frangipani — home","de":"Frangipani — Startseite"},"footer.newsletter":{"pl":"Newsletter","en":"Newsletter","de":"Newsletter"},"footer.social_label":{"pl":"Media społecznościowe","en":"Social media","de":"Soziale Medien"},"footer.info_label":{"pl":"Informacje i prywatność","en":"Information and privacy","de":"Informationen und Datenschutz"},"footer.help":{"pl":"Pomoc","en":"Help","de":"Hilfe"},"footer.shop":{"pl":"Sklep","en":"Shop","de":"Shop"},"footer.about":{"pl":"O Frangipani","en":"About Frangipani","de":"Über Frangipani"},"footer.journal":{"pl":"Journal","en":"Journal","de":"Journal"},"footer.architects":{"pl":"Dla architektów","en":"For architects","de":"Für Architekten"},"footer.showroom":{"pl":"Showroom · Zakręt k. Warszawy","en":"Showroom · Zakręt near Warsaw","de":"Showroom · Zakręt bei Warschau"},"footer.privacy":{"pl":"Prywatność","en":"Privacy","de":"Datenschutz"},"footer.close":{"pl":"Zamknij","en":"Close","de":"Schließen"},"footer.help_title":{"pl":"Pomoc i informacje","en":"Help and information","de":"Hilfe und Informationen"},"footer.help_nav_label":{"pl":"Pomoc i regulaminy","en":"Help and policies","de":"Hilfe und Richtlinien"},"footer.company_title":{"pl":"Kontakt, showroom i dane firmy","en":"Contact, showroom and company details","de":"Kontakt, Showroom und Unternehmensangaben"},"footer.newsletter_intro":{"pl":"Nowe obiekty, kolekcje i historie z Bali.","en":"New objects, collections and stories from Bali.","de":"Neue Objekte, Kollektionen und Geschichten aus Bali."},"footer.cookies":{"pl":"Cookies","en":"Cookies","de":"Cookies"},"footer.delivery_payment":{"pl":"Dostawa i płatności","en":"Delivery and payment","de":"Lieferung und Zahlung"},"footer.returns":{"pl":"Zwroty i reklamacje","en":"Returns and complaints","de":"Rückgaben und Reklamationen"},"footer.faq":{"pl":"FAQ","en":"FAQ","de":"FAQ"},"footer.terms":{"pl":"Warunki świadczenia usług","en":"Terms of service","de":"Nutzungsbedingungen"},"footer.shipping":{"pl":"Polityka wysyłki","en":"Shipping policy","de":"Versandbedingungen"},"footer.contact_information":{"pl":"Dane kontaktowe","en":"Contact information","de":"Kontaktinformationen"},"quickadd.close":{"pl":"Zamknij","en":"Close","de":"Schließen"},"quickadd.add":{"pl":"Dodaj do koszyka","en":"Add to cart","de":"In den Warenkorb"},"quickadd.product_details":{"pl":"Zobacz pełne informacje o produkcie","en":"View full product details","de":"Alle Produktinformationen ansehen"},"quickadd.go_product":{"pl":"Przejdź do produktu","en":"Go to the product","de":"Zum Produkt"},"quickadd.fetch_error":{"pl":"Nie udało się pobrać aktualnych danych produktu.","en":"We could not load the current product details.","de":"Die aktuellen Produktdaten konnten nicht geladen werden."},"quickadd.configure_product":{"pl":"Otwórz kartę produktu, aby wybrać jego konfigurację.","en":"Open the product page to choose its configuration.","de":"Öffne die Produktseite, um die Konfiguration auszuwählen."},"quickadd.variant_unconfirmed":{"pl":"Nie udało się potwierdzić wybranego wariantu.","en":"We could not confirm the selected option.","de":"Die ausgewählte Variante konnte nicht bestätigt werden."},"quickadd.variant_unavailable":{"pl":"Wybrany wariant nie jest obecnie dostępny do zamówienia.","en":"The selected option is currently unavailable to order.","de":"Die ausgewählte Variante kann derzeit nicht bestellt werden."},"quickadd.additional_choice":{"pl":"Ten produkt wymaga dodatkowego wyboru na jego karcie.","en":"This product requires an additional selection on its product page.","de":"Für dieses Produkt ist eine zusätzliche Auswahl auf der Produktseite erforderlich."},"quickadd.required_quantity":{"pl":"Wybierz wymaganą ilość na karcie produktu.","en":"Select the required quantity on the product page.","de":"Wähle die erforderliche Menge auf der Produktseite."},"quickadd.check_preorder":{"pl":"Sprawdź warunki przedsprzedaży na karcie produktu.","en":"Check the pre-order terms on the product page.","de":"Prüfe die Vorbestellbedingungen auf der Produktseite."},"quickadd.checking":{"pl":"Sprawdzamy dostępność…","en":"Checking availability…","de":"Verfügbarkeit wird geprüft…"},"quickadd.preorder":{"pl":"Przedsprzedaż","en":"Pre-order","de":"Vorbestellung"},"quickadd.availability":{"pl":"Przewidywana dostępność: {{date}}","en":"Expected availability: {{date}}","de":"Voraussichtliche Verfügbarkeit: {{date}}"},"quickadd.payment":{"pl":"Płatność: {{payment}}","en":"Payment: {{payment}}","de":"Zahlung: {{payment}}"},"quickadd.add_quantity":{"pl":"Dodaj {{count}} szt. do koszyka","en":"Add {{count}} items to cart","de":"{{count}} Stück in den Warenkorb legen"},"quickadd.check_variant_error":{"pl":"Nie udało się sprawdzić wariantu. Otwórz kartę produktu.","en":"We could not check this option. Open the product page.","de":"Die Variante konnte nicht geprüft werden. Öffne die Produktseite."},"quickadd.adding":{"pl":"Dodajemy do koszyka…","en":"Adding to cart…","de":"Wird zum Warenkorb hinzugefügt…"},"quickadd.add_error":{"pl":"Nie udało się dodać produktu. Sprawdź dostępność na jego karcie.","en":"We could not add the product. Check availability on its product page.","de":"Das Produkt konnte nicht hinzugefügt werden. Prüfe die Verfügbarkeit auf der Produktseite."},"quickadd.added":{"pl":"Produkt został dodany do koszyka.","en":"The product has been added to your cart.","de":"Das Produkt wurde deinem Warenkorb hinzugefügt."},"quickadd.go_cart":{"pl":"Przejdź do koszyka","en":"Go to cart","de":"Zum Warenkorb"},"quickadd.added_check_cart":{"pl":"Produkt został dodany. Otwórz koszyk, aby go zobaczyć.","en":"The product has been added. Open your cart to view it.","de":"Das Produkt wurde hinzugefügt. Öffne deinen Warenkorb, um es anzusehen."},"quickadd.add_unconfirmed":{"pl":"Nie udało się potwierdzić dodania produktu.","en":"We could not confirm that the product was added.","de":"Es konnte nicht bestätigt werden, dass das Produkt hinzugefügt wurde."},"quickadd.check_before_retry":{"pl":"{{message}} Sprawdź koszyk przed ponowną próbą.","en":"{{message}} Check your cart before trying again.","de":"{{message}} Prüfe deinen Warenkorb, bevor du es erneut versuchst."},"quickadd.check_cart":{"pl":"Sprawdź koszyk","en":"Check your cart","de":"Warenkorb prüfen"},"quickadd.option":{"pl":"Opcja {{number}}","en":"Option {{number}}","de":"Option {{number}}"},"quickadd.choose_size":{"pl":"Wybierz rozmiar","en":"Choose a size","de":"Größe auswählen"},"quickadd.choose_finish":{"pl":"Wybierz wykończenie","en":"Choose a finish","de":"Ausführung auswählen"},"quickadd.choose_option":{"pl":"Wybierz: {{name}}","en":"Choose: {{name}}","de":"Wähle: {{name}}"},"quickadd.edit_choice":{"pl":"{{name}}: {{value}} · Zmień","en":"{{name}}: {{value}} · Change","de":"{{name}}: {{value}} · Ändern"},"quickadd.full_configuration":{"pl":"Wybierz pełną konfigurację na karcie produktu.","en":"Choose the full configuration on the product page.","de":"Wähle die vollständige Konfiguration auf der Produktseite."},"quickadd.selected_options":{"pl":"Wybrane opcje","en":"Selected options","de":"Ausgewählte Optionen"},"quickadd.step":{"pl":"Krok {{step}} z {{total}}","en":"Step {{step}} of {{total}}","de":"Schritt {{step}} von {{total}}"},"quickadd.from_price":{"pl":"od {{price}}","en":"from {{price}}","de":"ab {{price}}"},"quickadd.unavailable":{"pl":"Niedostępny","en":"Unavailable","de":"Nicht verfügbar"},"quickadd.dimensions_key":{"pl":"Wymiary: wys. × szer. × dł.","en":"Dimensions: H × W × L","de":"Maße: H × B × L"},"quickadd.one_variant":{"pl":"Jeden wariant","en":"One option","de":"Eine Variante"},"quickadd.unavailable_variant":{"pl":"{{name}} — niedostępny","en":"{{name}} — unavailable","de":"{{name}} — nicht verfügbar"},"quickadd.loading":{"pl":"Wczytujemy produkt…","en":"Loading the product…","de":"Produkt wird geladen…"},"quickadd.choose_variant_page":{"pl":"Otwórz kartę produktu, aby wybrać wariant.","en":"Open the product page to choose an option.","de":"Öffne die Produktseite, um eine Variante auszuwählen."},"quickadd.choose_purchase":{"pl":"Wybierz sposób zakupu na karcie produktu.","en":"Choose your purchase option on the product page.","de":"Wähle die Kaufoption auf der Produktseite."},"quickadd.choose_variant":{"pl":"Wybierz wariant","en":"Choose an option","de":"Variante auswählen"},"quickadd.choose_variant_message":{"pl":"Wybierz wariant.","en":"Choose an option.","de":"Wähle eine Variante."},"quickadd.product_unavailable":{"pl":"Produkt jest obecnie niedostępny.","en":"The product is currently unavailable.","de":"Das Produkt ist derzeit nicht verfügbar."},"quickadd.load_error":{"pl":"Nie udało się wczytać produktu.","en":"We could not load the product.","de":"Das Produkt konnte nicht geladen werden."},"quickadd.product":{"pl":"produkt","en":"the product","de":"das Produkt"},"quickadd.add_named":{"pl":"Dodaj {{name}} do koszyka","en":"Add {{name}} to cart","de":"{{name}} in den Warenkorb legen"}};
  const frText = (key, values = {}) => {
    const message = frRuntimeMessages[key];
    const text = message?.[frRuntimeLocale] ?? message?.pl ?? key;
    return text.replace(/\{\{(\w+)\}\}/g, (_, name) => String(values[name] ?? ''));
  };

/* Explicit product choices: size first, then available finishes; Shopify owns the variant/cart. */
(() => {
  if (window.frangipaniSizeChoiceInstalled) return;
  window.frangipaniSizeChoiceInstalled = true;
  const states = new WeakMap();
  let dialog, dialogState;
  const normalize = value => String(value ?? '').trim().toLocaleLowerCase('pl');
  const isSizeName = name => /^(rozmiar|size|größe|grosse|groesse|taille|talla|wielkość)$/iu.test(name.trim());
  const isFinishName = name => /kolor|wykończenie|color|colour|finish|farbe|oberfläche|ausführung|fertigstellung/iu.test(name);
  const numberFormat = new Intl.NumberFormat(document.documentElement.lang || 'pl-PL', { maximumFractionDigits: 3 });
  const safeJSON = value => { try { return JSON.parse(value); } catch (_) { return null; } };

  function optionGroups(root) {
    const picker = root.querySelector('variant-selects');
    if (!picker) return [];
    return Array.from(picker.children).filter(node => node.matches('fieldset, .product-form__input')).map((node, position) => {
      const inputs = Array.from(node.querySelectorAll('input[type="radio"]'));
      const select = node.querySelector('select');
      const name = inputs[0]?.dataset.optionName || select?.selectedOptions?.[0]?.dataset.optionName || node.querySelector('legend, label')?.textContent.trim() || '';
      const values = inputs.length ? inputs.map(input => input.value) : Array.from(select?.options || []).filter(option => option.value).map(option => option.value);
      return { name, key: position + ':' + normalize(name), position, node, inputs, select, values, size: isSizeName(name) };
    }).filter(group => group.values.length);
  }
  function requiredGroups(root) {
    const groups = optionGroups(root);
    const size = groups.find(group => group.size);
    const hasFinishChoice = groups.some(group => isFinishName(group.name) && group.values.length > 1);
    if ((!size || (size.values.length < 2 && groups.length < 2)) && !hasFinishChoice) return [];
    return [...groups.filter(group => group.size), ...groups.filter(group => !group.size)];
  }
  const selectedValue = group => group.select ? group.select.value : group.inputs.find(input => input.checked)?.value;
  const promptFor = group => !group || group.size ? frText('choose_size') : /kolor|color|colour|farbe/iu.test(group.name) ? frText('choose_colour') : isFinishName(group.name) ? frText('choose_finish') : frText('choose_option', { option: group.name.toLocaleLowerCase(document.documentElement.lang || 'pl') });
  function widgetsFor(root) {
    return Array.from(document.querySelectorAll('fr-product-dimensions[data-reference]')).filter(widget => widget.dataset.productId === root.dataset.productId);
  }
  function catalog(state) {
    for (const widget of widgetsFor(state.root)) {
      const variants = Array.isArray(widget.variants) ? widget.variants : safeJSON(widget.dataset.variants);
      if (Array.isArray(variants) && variants.length) return variants;
    }
    return state.catalog;
  }
  function candidates(state, choices, availableOnly = true) {
    const variants = catalog(state);
    if (!Array.isArray(variants)) return null;
    const groups = optionGroups(state.root);
    return variants.filter(variant => Array.isArray(variant.options) && (!availableOnly || variant.available === true)
      && groups.every(group => !choices.has(group.key) || normalize(variant.options[group.position]) === normalize(choices.get(group.key))));
  }
  function nextGroup(state, groups = requiredGroups(state.root)) {
    return groups.find(group => !state.choices.has(group.key)) || null;
  }
  function choicesForOption(state, group, value) {
    const groups = requiredGroups(state.root);
    const choices = new Map();
    for (const prior of groups) {
      if (prior.key === group.key) break;
      if (state.choices.has(prior.key)) choices.set(prior.key, state.choices.get(prior.key));
    }
    choices.set(group.key, value);
    return choices;
  }
  function entryFor(root, variant) {
    for (const widget of widgetsFor(root)) {
      const entries = Array.isArray(widget.entries) ? widget.entries : [];
      if (entries.some(entry => entry.variantId)) {
        const matches = entries.filter(entry => String(entry.variantId) === String(variant.id));
        if (matches.length === 1) return matches[0];
        continue;
      }
      const names = Array.isArray(widget.optionNames) ? widget.optionNames : [];
      const size = names.findIndex(isSizeName);
      const finish = names.findIndex(isFinishName);
      if (size < 0) continue;
      const matches = entries.filter(entry => normalize(entry.label) === normalize(variant.options[size]) && (finish < 0 || normalize(entry.color) === normalize(variant.options[finish])));
      if (matches.length === 1) return matches[0];
    }
    return null;
  }
  function formatPrice(root, value) {
    const currency = root.querySelector('variant-selects')?.dataset.currencyCode || window.Shopify?.currency?.active;
    if (!Number.isFinite(value) || value < 0 || !/^[A-Z]{3}$/.test(currency || '')) return '';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'pl-PL', { style: 'currency', currency }).format(value / 100); }
    catch (_) { return ''; }
  }
  function optionData(state, group, value) {
    const matches = candidates(state, choicesForOption(state, group, value)) || [];
    const entries = matches.map(variant => entryFor(state.root, variant));
    const prices = matches.map(variant => variant.price).filter(Number.isFinite);
    const price = prices.length === matches.length && prices.length ? formatPrice(state.root, Math.min(...prices)) : '';
    const rangedPrice = new Set(prices).size > 1;
    const measures = {};
    for (const key of ['height', 'width', 'length', 'depth']) {
      const values = entries.map(entry => entry?.[key]);
      if (!values.length || !values.every(value => Number.isFinite(value) && value > 0)) continue;
      const min = Math.min(...values), max = Math.max(...values);
      measures[key] = numberFormat.format(min) + (max !== min ? '–' + numberFormat.format(max) : '');
    }
    return { matches, measures, reference: entries.some(entry => entry?.reference), price: price ? (rangedPrice ? frText('price_from', { price }) : price) : '' };
  }
  function update(state) {
    if (!state.root.isConnected) return;
    const groups = requiredGroups(state.root);
    const required = groups.length > 0;
    const picker = state.root.querySelector('variant-selects');
    // Visual ordering only: Shopify option positions keep their original DOM order.
    if (picker && groups.length > 1) {
      picker.classList.add('fr-choice-ordered');
      groups.forEach((group, index) => { if (group.node.style.order !== String(index)) group.node.style.order = String(index); });
    }
    const allChosen = required && groups.every(group => state.choices.has(group.key));
    const exact = allChosen ? candidates(state, state.choices) : [];
    const target = exact?.length === 1 ? exact[0] : null;
    const nativeId = state.root.querySelector('product-form form input[name="id"]')?.value;
    const confirmed = Boolean(target && String(target.id) === String(nativeId) && groups.every(group => normalize(selectedValue(group)) === normalize(state.choices.get(group.key))));
    if (confirmed) { state.applying = false; state.error = ''; }
    const next = nextGroup(state, groups);
    const prompt = state.applying ? frText('choosing_variant') : next ? promptFor(next) : required && !confirmed ? frText('confirm_choice') : frText('choose_size');
    let changed = false;
    for (const [key, value] of [['frSizeChoiceRequired', String(required)], ['frSizeChoiceConfirmed', String(confirmed)], ['frChoicePrompt', prompt]]) {
      if (state.root.dataset[key] !== value) { state.root.dataset[key] = value; changed = true; }
    }
    if (changed) state.root.dispatchEvent(new CustomEvent('fr:size-choice-change', { bubbles: true }));
    return confirmed;
  }
  function setChoice(state, group, value) {
    const groups = requiredGroups(state.root);
    const index = groups.findIndex(item => item.key === group.key);
    if (index < 0 || groups.slice(0, index).some(item => !state.choices.has(item.key))) return false;
    const matches = candidates(state, choicesForOption(state, group, value));
    if (!matches?.length) return false;
    if (normalize(state.choices.get(group.key)) !== normalize(value)) {
      groups.slice(index + 1).forEach(item => state.choices.delete(item.key));
    }
    state.choices.set(group.key, value);
    state.error = '';
    state.applying = false;
    update(state);
    return true;
  }
  function recordNative(state, control) {
    const group = requiredGroups(state.root).find(item => item.select === control || item.inputs.includes(control));
    if (!group || control.disabled || (!group.select && !control.checked)) return;
    setChoice(state, group, control.value);
  }
  async function loadCatalog(state) {
    if (Array.isArray(catalog(state)) || state.loading) return;
    state.loading = true;
    state.error = '';
    try {
      const url = new URL(state.root.dataset.url, window.location.origin);
      if (url.origin !== window.location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) throw new Error('Invalid product URL');
      url.pathname = url.pathname.replace(/\/$/, '') + '.js';
      url.search = '';
      const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Product unavailable');
      const product = await response.json();
      if (String(product.id) !== String(state.root.dataset.productId) || !Array.isArray(product.variants)) throw new Error('Invalid product data');
      state.catalog = product.variants;
    } catch (_) { state.error = frText('variant_load_failed'); }
    finally {
      state.loading = false;
      update(state);
      if (dialogState === state && dialog?.open) render(state);
    }
  }
  function commit(state) {
    const groups = requiredGroups(state.root);
    if (nextGroup(state, groups)) return;
    const matches = candidates(state, state.choices);
    if (matches?.length !== 1) { state.error = frText('variant_unavailable_finish'); render(state); return; }
    const controls = groups.map(group => ({ group, control: group.select || group.inputs.find(input => normalize(input.value) === normalize(state.choices.get(group.key))) }));
    if (controls.some(({ group, control }) => !control || control.disabled || (group.select && Array.from(control.options).find(option => normalize(option.value) === normalize(state.choices.get(group.key)))?.disabled))) {
      state.error = frText('variant_cannot_choose');
      render(state);
      return;
    }
    // Set the complete combination first; one native change avoids invalid interim
    // combinations (e.g. an L+ size that does not exist in the default finish).
    controls.forEach(({ group, control }) => {
      if (group.select) {
        control.value = state.choices.get(group.key);
        Array.from(control.options).forEach(option => option.toggleAttribute('selected', option.selected));
      } else control.checked = true;
    });
    if (update(state)) { if (dialogState === state) dialog.close(); return; }
    state.applying = true;
    state.error = '';
    update(state);
    const control = controls[controls.length - 1]?.control;
    control?.dispatchEvent(new Event('change', { bubbles: true }));
    if (dialogState === state) render(state);
  }
  function ensureDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'fr-quick-dialog fr-size-choice-dialog';
    dialog.setAttribute('aria-labelledby', 'fr-size-choice-title');
    dialog.innerHTML = '<button type="button" class="fr-quick-close" aria-label="' + frText('close') + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="m6 6 12 12M6 18 18 6"/></svg></button><h2 id="fr-size-choice-title">' + frText('choose_size') + '</h2><div class="fr-size-choice-content"></div>';
    dialog.querySelector('.fr-quick-close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => { dialogState = null; });
    document.body.append(dialog);
    return dialog;
  }
  function button(text, callback, className) {
    const element = document.createElement('button');
    element.type = 'button';
    element.textContent = text;
    if (className) element.className = className;
    element.addEventListener('click', event => { if (event.isTrusted) callback(); });
    return element;
  }
  function render(state) {
    update(state);
    const modal = ensureDialog();
    const content = modal.querySelector('.fr-size-choice-content');
    content.replaceChildren();
    const groups = requiredGroups(state.root);
    if (!groups.length) { modal.close(); return; }
    const group = nextGroup(state, groups) || groups[groups.length - 1];
    const step = groups.indexOf(group);
    modal.querySelector('h2').textContent = promptFor(group);
    if (groups.length > 1) {
      const progress = document.createElement('p');
      progress.className = 'fr-choice-progress';
      progress.textContent = frText('step', { current: step + 1, total: groups.length });
      content.append(progress);
    }
    if (step > 0) {
      const summary = document.createElement('div');
      summary.className = 'fr-choice-summary';
      const label = document.createElement('span');
      label.textContent = groups.slice(0, step).map(prior => prior.name + ': ' + state.choices.get(prior.key)).join(' · ');
      const back = button(frText('edit'), () => {
        groups.slice(step - 1).forEach(item => state.choices.delete(item.key));
        state.applying = false;
        state.error = '';
        update(state);
        render(state);
      }, 'fr-choice-back');
      back.disabled = state.applying;
      summary.append(label, back);
      content.append(summary);
    }
    if (!Array.isArray(catalog(state))) {
      const status = document.createElement('p');
      status.setAttribute('role', state.error ? 'alert' : 'status');
      status.textContent = state.error || frText('loading_variants');
      content.append(status);
      if (state.error) content.append(button(frText('retry'), () => { loadCatalog(state); render(state); }, 'fr-choice-retry'));
      else loadCatalog(state);
      return;
    }
    const options = document.createElement('div');
    options.className = 'fr-quick-options fr-size-options-table' + (!group.size ? ' fr-finish-options' : '');
    options.setAttribute('role', 'group');
    options.setAttribute('aria-label', group.name);
    const choices = group.values.map(value => ({ value, data: optionData(state, group, value) }));
    const hasDimensions = choices.some(({ data }) => Object.keys(data.measures).length);
    const hasPrice = choices.some(({ data }) => data.price);
    const reference = choices.some(({ data }) => data.reference);
    const axes = [['height', frText('height')], ['width', frText('width')], [reference ? 'length' : 'depth', reference ? frText('length') : frText('depth')]];
    // The first step is a compact measurement table; finishes use roomier named rows.
    options.classList.toggle('fr-size-options-table--dimensions', hasDimensions && group.size);
    options.classList.toggle('fr-size-options-table--prices', hasPrice);
    if (group.size && (hasDimensions || hasPrice)) {
      const headings = document.createElement('div');
      headings.className = 'fr-size-options-heading';
      headings.setAttribute('aria-hidden', 'true');
      [frText('size'), ...(hasDimensions ? axes.map(([, name]) => name) : []), ...(hasPrice ? [frText('price')] : [])].forEach(name => { const span = document.createElement('span'); span.textContent = name; headings.append(span); });
      options.append(headings);
    }
    for (const { value, data } of choices) {
      // Missing combinations never appear as selectable finishes.
      if (!group.size && !data.matches.length) continue;
      const choice = button('', () => {
        if (!setChoice(state, group, value)) return;
        if (nextGroup(state)) render(state); else commit(state);
      }, 'fr-size-option');
      const name = document.createElement('span');
      name.className = 'fr-size-option-name';
      name.textContent = value;
      choice.append(name);
      const accessible = [group.name + ' ' + value];
      if (hasDimensions && group.size) {
        axes.forEach(([key, title]) => {
          const span = document.createElement('span');
          span.className = 'fr-size-option-measure';
          span.textContent = data.measures[key] ? data.measures[key] + ' cm' : '—';
          choice.append(span);
          if (data.measures[key]) accessible.push(title + ' ' + data.measures[key] + ' cm');
        });
      } else if (hasDimensions) {
        const measurements = document.createElement('small');
        measurements.className = 'fr-finish-measures';
        measurements.textContent = axes.filter(([key]) => data.measures[key]).map(([key, title]) => title + ' ' + data.measures[key]).join(' × ') + ' cm';
        name.append(measurements);
        accessible.push(measurements.textContent);
      }
      if (hasPrice) {
        const price = document.createElement('span');
        price.className = 'fr-size-option-price';
        price.textContent = data.price || '—';
        choice.append(price);
        if (data.price) accessible.push(data.price);
      }
      choice.disabled = state.applying || !data.matches.length;
      choice.setAttribute('aria-label', accessible.join(', '));
      choice.setAttribute('aria-pressed', String(state.choices.get(group.key) === value));
      options.append(choice);
    }
    content.append(options);
    if (group.size && choices.some(({ data }) => Object.values(data.measures).some(value => value.includes('–')))) {
      const note = document.createElement('p');
      note.className = 'fr-choice-note';
      note.textContent = frText('dimensions_finish_note');
      content.append(note);
    }
    if (state.error || state.applying) {
      const status = document.createElement('p');
      status.className = 'fr-choice-status';
      status.setAttribute('role', state.error ? 'alert' : 'status');
      status.textContent = state.error || frText('loading_selected_variant');
      content.append(status);
    }
    if (modal.open && !modal.contains(document.activeElement)) {
      (modal.querySelector('.fr-size-option:not(:disabled)') || modal.querySelector('.fr-quick-close'))?.focus();
    }
  }
  function open(state) {
    update(state);
    if (!requiredGroups(state.root).length) return;
    const modal = ensureDialog();
    dialogState = state;
    render(state);
    if (typeof modal.showModal === 'function') {
      if (!modal.open) modal.showModal();
      modal.querySelector('.fr-quick-options button:not(:disabled)')?.focus();
    } else {
      const group = nextGroup(state) || requiredGroups(state.root)[0];
      group.node.scrollIntoView({ block: 'center' });
      (group.select || group.inputs.find(input => !input.disabled))?.focus();
    }
  }
  function setup(root) {
    if (states.has(root)) return;
    const state = { root, choices: new Map(), queued: false, catalog: null, loading: false, applying: false, error: '' };
    states.set(root, state);
    // Color-only products must not present Shopify's default finish as a customer choice.
    const initialGroups = requiredGroups(root);
    if (initialGroups.length && !initialGroups.some(group => group.size)) {
      initialGroups.filter(group => isFinishName(group.name)).forEach(group => {
        group.inputs.forEach(input => { input.checked = false; });
        if (group.select) {
          const placeholder = new Option(promptFor(group), '', true, true);
          placeholder.disabled = true;
          group.select.prepend(placeholder);
          group.select.value = '';
        }
      });
    }
    const pending = () => { update(state); return root.dataset.frSizeChoiceRequired === 'true' && root.dataset.frSizeChoiceConfirmed !== 'true'; };
    root.addEventListener('fr:choose-size', () => open(state));
    root.addEventListener('click', event => {
      const submit = event.target.closest?.('.fr-product__buy .product-form__submit');
      if (submit && root.contains(submit) && pending()) { event.preventDefault(); event.stopImmediatePropagation(); open(state); return; }
      if (event.isTrusted && event.target.matches?.('variant-selects input[type="radio"]')) recordNative(state, event.target);
    }, true);
    root.addEventListener('change', event => {
      if (event.isTrusted && event.target.matches?.('variant-selects input[type="radio"], variant-selects select')) recordNative(state, event.target);
    }, true);
    root.addEventListener('submit', event => {
      if (event.target.matches?.('product-form form[action*="/cart/add"]') && pending()) { event.preventDefault(); event.stopImmediatePropagation(); open(state); }
    }, true);
    state.observer = new MutationObserver(records => {
      const relevant = records.some(item => item.target.closest?.('variant-selects, product-form, .fr-variant-load-error') || [...item.addedNodes, ...item.removedNodes].some(node => node.matches?.('variant-selects, .fr-variant-load-error') || node.querySelector?.('variant-selects, .fr-variant-load-error')));
      if (!relevant || state.queued) return;
      state.queued = true;
      requestAnimationFrame(() => {
        state.queued = false;
        if (state.applying && root.querySelector('.fr-variant-load-error')) { state.applying = false; state.error = frText('variant_retry_choice'); }
        const confirmed = update(state);
        if (dialogState === state && dialog?.open) { if (confirmed) dialog.close(); else render(state); }
      });
    });
    state.observer.observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'disabled', 'aria-disabled'] });
    update(state);
    if (requiredGroups(root).length && !Array.isArray(catalog(state))) loadCatalog(state);
  }
  function dimensionsChoice(event) {
    if (!event.isTrusted) return;
    let control = event.target.closest?.('fr-product-dimensions[data-reference] button[data-size]');
    if (!control || control.disabled) return;
    const widget = control.closest('fr-product-dimensions');
    if (event.type === 'keydown') {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      const buttons = Array.from(control.parentElement.querySelectorAll('button[data-size]'));
      const index = buttons.indexOf(control);
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
      control = buttons[next];
    }
    const root = Array.from(document.querySelectorAll('[data-fr-product-root]')).find(item => item.dataset.productId === widget.dataset.productId);
    const state = root && states.get(root);
    const entry = widget.entries?.[Number(control.dataset.size)];
    if (!state || !entry || typeof widget.purchaseControl !== 'function') return;
    const purchase = widget.purchaseControl(entry);
    if (purchase?.radio) queueMicrotask(() => recordNative(state, purchase.radio));
    else if (purchase?.select) queueMicrotask(() => recordNative(state, purchase.select));
  }
  document.addEventListener('click', dimensionsChoice, true);
  document.addEventListener('keydown', dimensionsChoice, true);
  const initialize = () => document.querySelectorAll('[data-fr-product-root]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true }); else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('product-info:loaded', initialize);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-fr-product-root]').forEach(root => { const state = states.get(root); state?.observer.disconnect(); if (dialogState === state && dialog?.open) dialog.close(); });
  });
})();

/* Frangipani presentation refinements. Native product forms and cart remain authoritative. */
(() => {
  if (window.frangipaniRefinementsReady) return;
  window.frangipaniRefinementsReady = true;
  document.documentElement.classList.add('fr-refined');
  const arrow = '<svg class="fr-refine-arrow" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.1" aria-hidden="true" focusable="false"><path d="M5 19 19 5M5 5h14v14"/></svg>';
  function replaceArrows(scope) {
    scope.querySelectorAll('span[aria-hidden="true"]').forEach(el => {
      if (!el.querySelector('svg') && /^[\s]*↗[\uFE0E\uFE0F]?[\s]*$/u.test(el.textContent)) el.innerHTML = arrow;
    });
  }
  const chevron = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" aria-hidden="true"><path d="m5 7 5 5 5-5"/></svg>';
  const attr = (el, name, value) => { if (el.getAttribute(name) !== String(value)) el.setAttribute(name, value); };
  const text = (el, value) => { if (el.textContent !== value) el.textContent = value; };
  const roots = new WeakSet();
  function setup(root) {
    if (roots.has(root)) return;
    roots.add(root);
    const bar = document.createElement('div');
    bar.className = 'fr-mobile-buybar';
    bar.innerHTML = '<p class="fr-mobile-buy-error" role="alert" hidden></p><p class="fr-mobile-buy-note"></p><div class="fr-mobile-buyrow"><button type="button" class="button button--primary fr-mobile-buy" aria-haspopup="dialog"></button></div>';
    root.append(bar);
    new ResizeObserver(() => document.documentElement.style.setProperty('--fr-buybar-height', bar.offsetHeight + 'px')).observe(bar);
    const mobileBuy = bar.querySelector('.fr-mobile-buy');
    const note = bar.querySelector('.fr-mobile-buy-note');
    const error = bar.querySelector('.fr-mobile-buy-error');
    const mainButton = () => root.querySelector('.fr-product__buy .product-form__submit');
    const needsSize = () => root.dataset.frSizeChoiceRequired === 'true' && root.dataset.frSizeChoiceConfirmed !== 'true';
    mobileBuy.addEventListener('click', () => {
      if (needsSize()) { root.dispatchEvent(new CustomEvent('fr:choose-size')); return; }
      const main = mainButton();
      if (!main || main.disabled || main.getAttribute('aria-disabled') === 'true') return;
      const quantity = root.querySelector('input[name="quantity"]');
      if (quantity && !quantity.reportValidity()) { quantity.focus(); return; }
      main.click();
    });
    function addHeart(parent, className) {
      const original = root.querySelector('.fr-wishlist-toggle--product[data-fr-wishlist-button]');
      if (!original || !parent) return;
      let heart = parent.querySelector('.' + className);
      if (!heart) {
        heart = original.cloneNode(true);
        heart.classList.add(className);
        heart.removeAttribute('data-fr-wishlist-button');
        heart.removeAttribute('id');
        heart.type = 'button';
        heart.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
        heart.addEventListener('click', () => root.querySelector('.fr-wishlist-toggle--product[data-fr-wishlist-button]')?.click());
        parent.append(heart);
      }
      ['aria-pressed', 'aria-label'].forEach(name => attr(heart, name, original.getAttribute(name) || ''));
    }
    let queued = false;
    function sync() {
      queued = false;
      if (!root.isConnected) return;
      const main = mainButton();
      if (bar.hidden !== !main) bar.hidden = !main;
      if (!main) return;
      const disabled = main.disabled || main.getAttribute('aria-disabled') === 'true';
      const chooseSize = needsSize();
      const mobileDisabled = !chooseSize && disabled;
      if (mobileBuy.disabled !== mobileDisabled) mobileBuy.disabled = mobileDisabled;
      const priceRoot = root.querySelector('.fr-product__price');
      const price = (priceRoot?.querySelector('.price--on-sale .price-item--sale') || priceRoot?.querySelector('.price__regular .price-item--regular') || priceRoot?.querySelector('.price-item'))?.textContent.trim().replace(/\s+PLN$/, '') || '';
      const label = main.querySelector('span')?.textContent.trim() || main.textContent.trim();
      const fullLabel = !disabled && price && !/\d/.test(label) ? label + ' — ' + price : label;
      const isPreorder = ['preorder', 'made_to_order'].includes(root.dataset.purchaseMode);
      const busy = main.classList.contains('loading');
      const compactLabel = fullLabel.replace(/^Zamawiam w przedsprzedaży/iu, frText('add_to_cart')).replace(/([,.])00(?=\s*[^\d]*$)/u, '').replace(/\s+(zł|PLN)$/u, '\u00a0$1');
      const choicePrompt = root.dataset.frChoicePrompt || frText('choose_size');
      const mobileLabel = chooseSize ? choicePrompt : compactLabel;
      const accessibleLabel = mobileLabel;
      text(mobileBuy, busy ? frText('adding') : mobileLabel);
      attr(mobileBuy, 'aria-label', busy ? frText('adding_to_cart') : accessibleLabel);
      attr(mobileBuy, 'aria-busy', String(busy));
      // Keep the native caption intact for the theme's variant/cart lifecycle.
      // A separate visual caption prevents the long preorder wording from wrapping.
      const showCompact = chooseSize || isPreorder;
      let compact = main.querySelector('.fr-buy-label');
      if (showCompact && !compact) {
        compact = document.createElement('span');
        compact.className = 'fr-buy-label';
        main.append(compact);
      }
      main.toggleAttribute('data-fr-compact-label', showCompact);
      if (compact) { if (compact.hidden !== !showCompact) compact.hidden = !showCompact; text(compact, chooseSize ? choicePrompt : compactLabel); }
      if (showCompact) attr(main, 'aria-label', accessibleLabel);
      else if (main.hasAttribute('aria-label')) main.removeAttribute('aria-label');
      const preorder = ['preorder', 'made_to_order'].includes(root.dataset.purchaseMode) ? root.querySelector('.fr-preorder-card') : null;
      const availability = Array.from(preorder?.querySelectorAll('dl > div') || []).find(row => row.querySelector('dt')?.textContent.match(/przewidywana|expected availability|voraussichtliche verfügbarkeit/iu))?.querySelector('dd')?.textContent.trim();
      const message = preorder ? [frText('preorder'), availability].filter(Boolean).join(' · ') : root.querySelector('.fr-product__shipping-note')?.textContent.trim() || '';
      text(note, message);
      if (note.hidden !== !message) note.hidden = !message;
      const nativeError = root.querySelector('.product-form__error-message-wrapper:not([hidden]) .product-form__error-message');
      const errorMessage = nativeError?.textContent.trim() || '';
      text(error, errorMessage);
      if (error.hidden !== !errorMessage) error.hidden = !errorMessage;
      addHeart(bar.querySelector('.fr-mobile-buyrow'), 'fr-mobile-buy-heart');
      addHeart(main.parentElement, 'fr-desktop-buy-heart');
      const lead = root.querySelector('.fr-product__lead:not(.fr-lead-full):not([data-fr-copy-reviewed])');
      if (lead) {
        lead.classList.add('fr-lead-full');
        const details = document.createElement('details');
        details.className = 'fr-mobile-lead';
        details.innerHTML = '<summary>' + frText('product_description') + chevron + '</summary>';
        lead.before(details);
        details.append(lead);
      }
      const dispatch = root.querySelector('.fr-product__dispatch-note:not(.fr-dispatch-full)');
      if (dispatch && dispatch.textContent.trim().length > 100) {
        dispatch.classList.add('fr-dispatch-full');
        const details = document.createElement('details');
        details.className = 'fr-dispatch-details';
        const summary = document.createElement('summary');
        const title = document.createElement('span');
        title.textContent = ['preorder', 'made_to_order'].includes(root.dataset.purchaseMode)
          ? frText('dispatch_after_arrival') : frText('shipping_information');
        summary.append(title);
        summary.insertAdjacentHTML('beforeend', chevron);
        details.append(summary);
        dispatch.before(details);
        details.append(dispatch);
      }
      replaceArrows(root);
    }
    root.addEventListener('fr:size-choice-change', sync);
    new MutationObserver(() => { if (!queued) { queued = true; requestAnimationFrame(sync); } }).observe(root, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','aria-pressed','aria-label','hidden']});
    sync();
  }
  function init() {
    replaceArrows(document);
    document.querySelectorAll('[data-fr-product-root]').forEach(setup);
    document.querySelectorAll('.fr-mobile-menu-favorites').forEach(el => el.remove());
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('product-info:loaded', init);
})();

/* Render directional arrows consistently, including iOS emoji-capable characters. */
(() => {
  if (window.frangipaniArrowIconsInstalled) return;
  window.frangipaniArrowIconsInstalled = true;

  const arrowPattern = /[↗↘↙↖➡⬅⬆⬇↑↓←→][\uFE0E\uFE0F]?/gu;
  const hasArrow = /[↗↘↙↖➡⬅⬆⬇↑↓←→]/u;
  const excluded = 'script, style, svg, textarea, input, select, option, code, pre, template, noscript, [data-fr-arrow-icon]';
  const angles = { '→': 0, '➡': 0, '←': 180, '⬅': 180, '↑': -90, '⬆': -90, '↓': 90, '⬇': 90, '↗': -45, '↘': 45, '↙': 135, '↖': -135 };
  const svgNamespace = 'http://www.w3.org/2000/svg';
  const pending = new Set();
  let frame = null;

  function eligible(node) {
    const parent = node.parentElement;
    return Boolean(parent && !parent.isContentEditable && !parent.closest(excluded));
  }

  function icon(character) {
    const svg = document.createElementNS(svgNamespace, 'svg');
    svg.setAttribute('data-fr-arrow-icon', '');
    svg.setAttribute('class', 'fr-refine-arrow');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '16');
    svg.setAttribute('height', '16');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.1');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.style.cssText = 'display:inline-block;vertical-align:middle;flex-shrink:0;pointer-events:none';
    const path = document.createElementNS(svgNamespace, 'path');
    path.setAttribute('d', 'M4 12h16m-6-6 6 6-6 6');
    path.setAttribute('transform', 'rotate(' + angles[character] + ' 12 12)');
    svg.append(path);
    return svg;
  }

  function replace(node) {
    if (!eligible(node) || !hasArrow.test(node.data)) return;
    const value = node.data;
    const fragment = document.createDocumentFragment();
    let cursor = 0;
    arrowPattern.lastIndex = 0;
    for (const match of value.matchAll(arrowPattern)) {
      if (match.index > cursor) fragment.append(document.createTextNode(value.slice(cursor, match.index)));
      fragment.append(icon(match[0][0]));
      cursor = match.index + match[0].length;
    }
    if (cursor < value.length) fragment.append(document.createTextNode(value.slice(cursor)));
    node.replaceWith(fragment);
  }

  function scan(scope) {
    if (!scope.isConnected) return;
    if (scope.nodeType === Node.TEXT_NODE) { replace(scope); return; }
    if (scope.nodeType !== Node.ELEMENT_NODE || scope.isContentEditable || scope.closest(excluded)) return;
    const walker = document.createTreeWalker(scope, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          return node.isContentEditable || node.matches(excluded) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_SKIP;
        }
        return hasArrow.test(node.data) && eligible(node) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    // Collect first so replacing one text node cannot invalidate traversal.
    const textNodes = [];
    for (let node = walker.nextNode(); node; node = walker.nextNode()) textNodes.push(node);
    textNodes.forEach(replace);
  }

  function flush() {
    frame = null;
    const scopes = Array.from(pending);
    pending.clear();
    // A newly inserted parent already includes its descendants.
    scopes.filter(scope => !scopes.some(other => other !== scope && other.contains?.(scope))).forEach(scan);
  }

  function enqueue(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      if (!hasArrow.test(node.data) || !eligible(node)) return;
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      if (node.isContentEditable || node.closest(excluded) || !hasArrow.test(node.textContent)) return;
    } else return;
    pending.add(node);
    if (frame === null) frame = requestAnimationFrame(flush);
  }

  function start() {
    scan(document.body);
    new MutationObserver(records => {
      records.forEach(record => {
        if (record.type === 'characterData') enqueue(record.target);
        else record.addedNodes.forEach(enqueue);
      });
    }).observe(document.body, { subtree: true, childList: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

/* Frangipani vertical product gallery. Keeps Shopify product/variant media updates intact. */
(() => {
  if (window.frangipaniGalleryInitialized) return;
  window.frangipaniGalleryInitialized = true;
  const selector = '.fr-product__media';
  const instances = new Map();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function createGallery(gallery, list) {
    const abort = new AbortController();
    const listen = (node, name, callback, options = {}) => node.addEventListener(name, callback, { ...options, signal: abort.signal });
    let slides = [], buttons = [];
    let targetIndex = 0, settledIndex = 0, animating = false;
    let settleTimer, refreshFrame;
    let observedActiveMedia = null;
    let lastWidth = 0, lastHeight = 0;
    let lastPlayedMedia = null;
    const oldTabindex = list.getAttribute('tabindex');
    const oldLabel = list.getAttribute('aria-label');
    const thumbs = document.createElement('nav');
    thumbs.className = 'fr-gallery-thumbnails';
    thumbs.setAttribute('aria-label', frText('product_photos'));
    gallery.prepend(thumbs);
    gallery.classList.add('fr-paged-gallery');
    list.tabIndex = 0;
    list.setAttribute('aria-label', frText('product_gallery'));

    const clamp = index => Math.max(0, Math.min(slides.length - 1, index));
    const top = index => slides[clamp(index)] ? slides[clamp(index)].offsetTop - slides[0].offsetTop : 0;
    const nearest = () => slides.reduce((best, slide, index) => Math.abs(top(index) - list.scrollTop) < Math.abs(top(best) - list.scrollTop) ? index : best, 0);
    const current = () => gallery.isConnected && gallery.querySelector('.product__media-list') === list;

    function select(index) {
      index = clamp(index);
      buttons.forEach((button, buttonIndex) => button.setAttribute('aria-current', String(buttonIndex === index)));
      const status = gallery.querySelector('[role="status"]');
      if (status) status.textContent = frText('media_position', { current: index + 1, total: slides.length });
      const button = buttons[index];
      if (button && thumbs.clientHeight) {
        const y = button.offsetTop - thumbs.offsetTop;
        if (y < thumbs.scrollTop || y + button.offsetHeight > thumbs.scrollTop + thumbs.clientHeight) {
          thumbs.scrollTo({ top: y - thumbs.clientHeight / 2 + button.offsetHeight / 2, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
        }
      }
    }

    function activate(index) {
      const active = slides[index];
      if (!active) return;
      observedActiveMedia = active;
      slides.forEach(slide => slide.classList.toggle('is-active', slide === active));
      // Use the theme's media lifecycle, but not its horizontal/page scrolling.
      if (active !== lastPlayedMedia) {
        const nativeGallery = gallery.querySelector('media-gallery');
        if (typeof nativeGallery?.playActiveMedia === 'function' && typeof window.pauseAllMedia === 'function') {
          nativeGallery.playActiveMedia(active);
        }
        lastPlayedMedia = active;
      }
    }

    function settle() {
      clearTimeout(settleTimer);
      if (!current() || !slides.length) return;
      settledIndex = nearest();
      animating = false;
      targetIndex = settledIndex;
      select(settledIndex);
      activate(settledIndex);
    }

    function go(index, instant = false) {
      if (!current() || !slides.length) return;
      index = clamp(index);
      if (!instant && index === targetIndex && animating) return;
      clearTimeout(settleTimer);
      targetIndex = index;
      animating = Math.abs(list.scrollTop - top(index)) > 1;
      select(index);
      list.scrollTo({ top: top(index), left: 0, behavior: instant || reducedMotion.matches ? 'instant' : 'smooth' });
      if (!animating || instant || reducedMotion.matches) settle();
    }

    function sync(force = false) {
      if (!current() || !slides.length || !list.clientWidth || !list.clientHeight) return;
      const changed = Math.abs(lastWidth - list.clientWidth) > 1 || Math.abs(lastHeight - list.clientHeight) > 1;
      if ((force || changed) && !animating) {
        lastWidth = list.clientWidth;
        lastHeight = list.clientHeight;
        list.scrollTo({ top: top(targetIndex), left: 0, behavior: 'instant' });
        slides.forEach(slide => {
          slide.querySelectorAll('.product__media img, .deferred-media__poster img').forEach(img => { img.sizes = Math.ceil(list.clientWidth) + 'px'; });
        });
      }
    }

    function refresh() {
      refreshFrame = null;
      if (!current()) return;
      const oldSlide = slides[targetIndex];
      slides = Array.from(list.children).filter(slide => slide.matches('li.product__media-item:not([hidden])'));
      if (!slides.length) return;
      const firstImage = slides[0].querySelector('.product__media img, .deferred-media__poster img, img');
      const ratio = Number(firstImage?.getAttribute('width')) / Number(firstImage?.getAttribute('height'));
      gallery.style.setProperty('--fr-gallery-ratio', Number.isFinite(ratio) && ratio > 0 ? String(ratio) : '.8');
      gallery.classList.toggle('fr-gallery--single', slides.length < 2);
      thumbs.replaceChildren();
      buttons = slides.map((slide, index) => {
        const image = slide.querySelector('.product__media img, .deferred-media__poster img, img');
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', frText('show_media', { current: index + 1, total: slides.length }));
        if (image?.currentSrc || image?.src) {
          const thumbnail = document.createElement('img');
          thumbnail.src = image.currentSrc || image.src;
          thumbnail.alt = '';
          thumbnail.loading = 'lazy';
          button.append(thumbnail);
        } else {
          // Video/model media may have no preview image. Retain a usable control.
          const number = document.createElement('span');
          number.textContent = String(index + 1);
          number.setAttribute('aria-hidden', 'true');
          button.append(number);
        }
        button.addEventListener('click', () => go(index));
        thumbs.append(button);
        return button;
      });
      const activeIndex = slides.findIndex(slide => slide.classList.contains('is-active'));
      targetIndex = activeIndex >= 0 ? activeIndex : Math.max(0, slides.indexOf(oldSlide));
      settledIndex = targetIndex;
      observedActiveMedia = slides[targetIndex];
      animating = false;
      sync(true);
      select(targetIndex);
    }

    listen(list, 'scroll', () => {
      if (!current()) return;
      // Never replace a smooth-scroll destination with an intermediate frame.
      if (!animating) { settledIndex = nearest(); targetIndex = settledIndex; select(settledIndex); }
      clearTimeout(settleTimer);
      settleTimer = setTimeout(settle, 130);
    }, { passive: true });
    listen(list, 'scrollend', settle);
    listen(list, 'wheel', event => {
      if (event.ctrlKey || !event.deltaY || Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
      // The browser owns wheel scrolling and inertia. A wheel gesture supersedes
      // a thumbnail/keyboard destination without forcing another scroll position.
      clearTimeout(settleTimer);
      animating = false;
      targetIndex = nearest();
    }, { passive: true });
    listen(list, 'pointerdown', event => {
      if (event.pointerType === 'touch' && animating) {
        animating = false;
        targetIndex = nearest();
        clearTimeout(settleTimer);
        list.scrollTo({ top: list.scrollTop, behavior: 'instant' });
      }
    }, { passive: true });
    listen(list, 'keydown', event => {
      if (event.target.closest('input, textarea, select, video, model-viewer, iframe, [contenteditable="true"]')) return;
      const next = { ArrowDown: targetIndex + 1, PageDown: targetIndex + 1, ArrowUp: targetIndex - 1, PageUp: targetIndex - 1, Home: 0, End: slides.length - 1 }[event.key];
      if (next !== undefined && slides.length > 1) { event.preventDefault(); go(next); }
    });

    const mediaObserver = new MutationObserver(records => {
      if (!current()) return;
      if (records.some(record => record.type === 'childList' && record.target === list || record.type === 'attributes' && record.attributeName === 'hidden')) {
        cancelAnimationFrame(refreshFrame);
        refreshFrame = requestAnimationFrame(refresh);
        return;
      }
      if (refreshFrame != null || !records.some(record => record.type === 'attributes' && record.target.parentElement === list && record.attributeName === 'class')) return;
      // Variant selection is still owned by Shopify and can activate another image.
      const activeIndex = slides.findIndex(slide => slide.classList.contains('is-active'));
      const activeMedia = slides[activeIndex];
      if (activeMedia && activeMedia !== observedActiveMedia) {
        observedActiveMedia = activeMedia;
        go(activeIndex, true);
      }
    });
    mediaObserver.observe(list, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden'] });
    const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(() => sync()) : null;
    resizeObserver?.observe(list);
    listen(window, 'resize', () => sync());
    refresh();

    return {
      list,
      destroy() {
        abort.abort();
        mediaObserver.disconnect();
        resizeObserver?.disconnect();
        clearTimeout(settleTimer);
        cancelAnimationFrame(refreshFrame);
        thumbs.remove();
        gallery.classList.remove('fr-paged-gallery', 'fr-gallery--single');
        if (oldTabindex === null) list.removeAttribute('tabindex'); else list.setAttribute('tabindex', oldTabindex);
        if (oldLabel === null) list.removeAttribute('aria-label'); else list.setAttribute('aria-label', oldLabel);
      }
    };
  }

  function initGallery(gallery) {
    const list = gallery.querySelector('.product__media-list');
    const existing = instances.get(gallery);
    if (existing?.list === list) return;
    existing?.destroy();
    instances.delete(gallery);
    if (list?.querySelector(':scope > li.product__media-item')) instances.set(gallery, createGallery(gallery, list));
  }
  function initAll(scope = document) {
    if (scope.matches?.(selector)) initGallery(scope);
    scope.querySelectorAll?.(selector).forEach(initGallery);
  }
  function start() {
    initAll();
    // Filtered variants replace media-gallery; product swaps can replace the whole product.
    new MutationObserver(records => {
      const candidates = new Set();
      records.forEach(record => record.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.matches('media-gallery, .product__media-list')) {
          const gallery = node.closest(selector);
          if (gallery) candidates.add(gallery);
        }
        if (node.matches(selector)) candidates.add(node);
        node.querySelectorAll(selector).forEach(gallery => candidates.add(gallery));
      }));
      candidates.forEach(initGallery);
      for (const [gallery, instance] of instances) {
        if (!gallery.isConnected) { instance.destroy(); instances.delete(gallery); }
      }
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', event => initAll(event.target));
    document.addEventListener('product-info:loaded', event => initAll(event.target));
    document.addEventListener('shopify:section:unload', event => {
      for (const [gallery, instance] of instances) {
        if (event.target.contains(gallery)) { instance.destroy(); instances.delete(gallery); }
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

/* Frangipani footer: reuse live theme links and the original newsletter form. */
(() => {
  if (window.frangipaniFooterInstalled) return;
  window.frangipaniFooterInstalled = true;

  const instances = new WeakMap();

  function enhance(original) {
    if (instances.has(original) || original.dataset.frMinFooterReady) return;
    if (typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;

    const links = Array.from(original.querySelectorAll('a'));
    const linkRoles = {"shop":{"paths":["/collections/all","/collections"],"labels":["Sklep","Shop","Store"]},"about":{"paths":["/pages/o-nas"],"views":["about"],"labels":["O nas","About us","Über uns","O Frangipani","About Frangipani","Über Frangipani"]},"journal":{"paths":["/blogs/frangipani-stories"],"views":["journal"],"labels":["Journal"]},"architects":{"paths":["/pages/dla-architektow"],"views":["architects"],"labels":["Dla architektów","For architects","Für Architekten"]},"stores":{"paths":["/pages/sklepy-frangipani"],"views":["stores"],"labels":["Sklepy Frangipani","Frangipani stores","Frangipani Stores","Showroom"]},"contact":{"paths":["/pages/contact","/pages/kontakt"],"labels":["Kontakt","Contact"]},"delivery_payment":{"paths":["/pages/dostawa-i-zwroty"],"views":["delivery-returns"],"labels":["Dostawa i płatności","Delivery and payment","Lieferung und Zahlung"]},"returns":{"paths":["/policies/refund-policy"],"labels":["Zwroty i reklamacje","Returns and complaints","Rückgaben und Reklamationen"]},"faq":{"paths":["/pages/faq"],"views":["faq"],"labels":["FAQ"]},"privacy":{"paths":["/policies/privacy-policy"],"labels":["Polityka prywatności","Privacy policy","Datenschutzerklärung","Datenschutzrichtlinie"]},"terms":{"paths":["/policies/terms-of-service"],"labels":["Warunki świadczenia usług","Terms of service","Nutzungsbedingungen","Terms and conditions","Allgemeine Geschäftsbedingungen"]},"shipping":{"paths":["/policies/shipping-policy"],"labels":["Polityka wysyłki","Shipping policy","Versandbedingungen","Versandrichtlinie"]},"contact_information":{"paths":["/policies/contact-information"],"labels":["Dane kontaktowe","Contact information","Kontaktinformationen"]},"directions":{"external":"maps","labels":["Wyznacz trasę","Get directions","Directions","Route planen","Wegbeschreibung"]},"instagram":{"external":"instagram","labels":["Instagram"]},"pinterest":{"external":"pinterest","labels":["Pinterest"]},"linkedin":{"external":"linkedin","labels":["LinkedIn"]},"cookies":{"labels":["Preferencje dotyczące plików cookie","Cookie preferences","Cookie settings","Cookie-Einstellungen","Cookie-Präferenzen"]}};
    const normalizedLabel = value => String(value || '').trim().replace(/\s+/g, ' ').toLocaleLowerCase();
    const linkByRole = name => {
      const role = linkRoles[name];
      if (!role) return undefined;
      const semanticMatch = links.find(link => {
        const href = link.getAttribute('href');
        if (!href) return false;
        let url;
        try { url = new URL(href, location.href); } catch (_) { return false; }
        if (role.external) {
          const host = url.hostname.toLowerCase();
          if (role.external === 'maps') return host === 'maps.app.goo.gl' || (/^(?:[a-z0-9-]+\.)?google\.[a-z.]+$/.test(host) && url.pathname.startsWith('/maps')) || host.startsWith('maps.google.');
          return host === `${role.external}.com` || host.endsWith(`.${role.external}.com`);
        }
        if (url.origin !== location.origin) return false;
        const path = url.pathname.replace(/^\/(?:pl|en|de)(?=\/|$)/i, '').replace(/\/$/, '') || '/';
        const view = url.searchParams.get('view');
        if (view) return Boolean(role.views?.includes(view) && ['/pages/contact', '/pages/kontakt'].includes(path));
        return Boolean(role.paths?.includes(path));
      });
      return semanticMatch || links.find(link => role.labels.some(label => normalizedLabel(link.textContent) === normalizedLabel(label)));
    };
    const cloneLink = (link, label) => {
      if (!link) return null;
      const copy = link.cloneNode(false);
      copy.removeAttribute('id');
      copy.removeAttribute('aria-labelledby');
      copy.removeAttribute('aria-describedby');
      copy.className = '';
      if (label) {
        copy.removeAttribute('aria-label');
        copy.removeAttribute('title');
      }
      copy.textContent = label || link.textContent.trim();
      return copy;
    };

    const footer = document.createElement('footer');
    footer.className = 'fr-min-footer';
    footer.id = 'fr-min-footer';
    footer.setAttribute('aria-label', frText('footer.aria_label'));
    footer.innerHTML = '<div class="fr-min-footer__inner"><div class="fr-min-footer__top"><nav class="fr-min-footer__nav" aria-label="Frangipani"><ul></ul></nav><div class="fr-min-footer__contact"><h2></h2></div></div><a class="fr-min-footer__brand"></a><div class="fr-min-footer__extra"><button type="button" data-fr-footer-open="newsletter"></button><nav class="fr-min-footer__social"></nav></div><div class="fr-min-footer__bottom"><small></small><nav><button type="button" data-fr-footer-open="help"></button></nav></div></div>';
    footer.querySelector('.fr-min-footer__contact h2').textContent = frText('footer.contact');
    footer.querySelector('.fr-min-footer__brand').setAttribute('aria-label', frText('footer.home_label'));
    footer.querySelector('[data-fr-footer-open="newsletter"]').textContent = frText('footer.newsletter');
    footer.querySelector('.fr-min-footer__social').setAttribute('aria-label', frText('footer.social_label'));
    footer.querySelector('.fr-min-footer__bottom nav').setAttribute('aria-label', frText('footer.info_label'));
    footer.querySelector('[data-fr-footer-open="help"]').textContent = frText('footer.help');

    const list = footer.querySelector('.fr-min-footer__nav ul');
    ['shop', 'about', 'journal', 'architects'].forEach(name => {
      const link = cloneLink(linkByRole(name), frText(`footer.${name}`));
      if (!link) return;
      const item = document.createElement('li');
      item.append(link);
      list.append(item);
    });

    const contact = footer.querySelector('.fr-min-footer__contact');
    ['mailto:', 'tel:'].forEach(prefix => {
      const link = cloneLink(links.find(item => item.getAttribute('href')?.startsWith(prefix)));
      if (link) contact.append(link);
    });
    const stores = cloneLink(linkByRole('stores'), frText('footer.showroom'));
    if (stores) {
      stores.className = 'fr-min-footer__showroom';
      contact.append(stores);
    }
    const map = cloneLink(linkByRole('directions'), 'ul. Lubelska 6, Zakręt');
    if (map) contact.append(map);

    const logo = document.querySelector('.header__heading-logo');
    const brand = footer.querySelector('.fr-min-footer__brand');
    brand.href = logo?.closest('a')?.getAttribute('href') || window.Shopify?.routes?.root || '/';
    if (logo) {
      const image = logo.cloneNode(true);
      image.removeAttribute('id');
      image.removeAttribute('style');
      image.className = '';
      image.alt = 'Frangipani';
      image.loading = 'lazy';
      brand.append(image);
    } else {
      // Do not replace the brand with an invented logo if the theme markup changes.
      return;
    }

    ['Instagram', 'Pinterest', 'LinkedIn'].forEach(text => {
      const link = cloneLink(linkByRole(text.toLowerCase()), text);
      if (link) footer.querySelector('.fr-min-footer__social').append(link);
    });
    footer.querySelector('.fr-min-footer__bottom small').textContent = `© ${new Date().getFullYear()} Frangipani`;
    const bottom = footer.querySelector('.fr-min-footer__bottom nav');
    const privacy = cloneLink(linkByRole('privacy'), frText('footer.privacy'));
    if (privacy) bottom.append(privacy);

    function makeDialog(title, name) {
      const dialog = document.createElement('dialog');
      dialog.className = 'fr-min-dialog';
      dialog.id = `fr-min-dialog-${name}`;
      dialog.setAttribute('aria-labelledby', `${dialog.id}-title`);
      dialog.innerHTML = '<button type="button" class="fr-min-dialog__close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="m6 6 12 12M6 18 18 6"/></svg></button><h2></h2><div class="fr-min-dialog__content"></div>';
      dialog.querySelector('.fr-min-dialog__close').setAttribute('aria-label', frText('footer.close'));
      const heading = dialog.querySelector('h2');
      heading.id = `${dialog.id}-title`;
      heading.textContent = title;
      dialog.querySelector('button').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      footer.append(dialog);
      return dialog;
    }

    const help = makeDialog(frText('footer.help_title'), 'help');
    const helpNav = document.createElement('nav');
    helpNav.className = 'fr-min-help-links';
    helpNav.setAttribute('aria-label', frText('footer.help_nav_label'));
    const unique = new Set();
    ['contact', 'delivery_payment', 'returns', 'faq', 'terms', 'shipping', 'contact_information'].forEach(name => {
      const link = cloneLink(linkByRole(name), frText(`footer.${name}`));
      if (!link || unique.has(link.href)) return;
      unique.add(link.href);
      helpNav.append(link);
    });
    const helpBody = help.querySelector('.fr-min-dialog__content');
    helpBody.append(helpNav);
    const company = original.querySelector('#Footer-Heading-company')?.parentElement.querySelector('.footer-block__details-content');
    if (company) {
      const details = document.createElement('details');
      details.className = 'fr-min-company';
      const summary = document.createElement('summary');
      summary.textContent = frText('footer.company_title');
      const content = company.cloneNode(true);
      content.classList.add('fr-min-company__content');
      [content, ...content.querySelectorAll('[id]')].forEach(element => element.removeAttribute('id'));
      details.append(summary, content);
      helpBody.append(details);
    }

    const newsletter = makeDialog(frText('footer.newsletter'), 'newsletter');
    // Keep body-mounted CAPTCHA challenges interactive above the newsletter panel.
    const newsletterBackdrop = document.createElement('div');
    newsletterBackdrop.className = 'fr-min-newsletter-backdrop';
    newsletterBackdrop.setAttribute('aria-hidden', 'true');
    newsletter.after(newsletterBackdrop);
    let newsletterOrigin;
    const onNewsletterEscape = event => {
      if (event.key === 'Escape' && newsletter.open && !help.open && !event.defaultPrevented) newsletter.close();
    };
    const openNewsletter = () => {
      newsletterOrigin = document.activeElement;
      newsletter.show();
      document.addEventListener('keydown', onNewsletterEscape);
    };
    newsletterBackdrop.addEventListener('click', () => newsletter.close());
    newsletter.addEventListener('close', () => {
      document.removeEventListener('keydown', onNewsletterEscape);
      if (newsletterOrigin?.isConnected && (newsletter.contains(document.activeElement) || document.activeElement === document.body)) newsletterOrigin.focus?.({ preventScroll: true });
    });
    const news = original.querySelector('.footer-block__newsletter');
    const form = news?.querySelector('form');
    const newsletterButton = footer.querySelector('[data-fr-footer-open="newsletter"]');
    if (!form) newsletterButton.remove();
    const cookies = links.find(link => link.getAttribute('href') === '#shopifyReshowConsentBanner') || linkByRole('cookies');
    const newsAnchor = news && document.createComment('Frangipani newsletter original position');
    const cookieAnchor = cookies && document.createComment('Frangipani cookie preferences original position');
    const cookieText = cookies?.textContent;
    const cookieClass = cookies?.className;

    try {
      // Move the actual nodes so consent handlers, form tokens, field IDs and app bindings survive.
      if (form) {
        news.before(newsAnchor);
        const intro = document.createElement('p');
        intro.textContent = frText('footer.newsletter_intro');
        newsletter.querySelector('.fr-min-dialog__content').append(intro, news);
      }
      if (cookies) {
        cookies.before(cookieAnchor);
        cookies.className = '';
        cookies.textContent = frText('footer.cookies');
        bottom.append(cookies);
      }
      const dialogs = { help, newsletter };
      footer.querySelectorAll('[data-fr-footer-open]').forEach(button => {
        const dialog = dialogs[button.dataset.frFooterOpen];
        button.setAttribute('aria-controls', dialog.id);
        button.setAttribute('aria-haspopup', 'dialog');
        button.addEventListener('click', () => {
          if (!dialog.open) dialog === newsletter ? openNewsletter() : dialog.showModal();
        });
      });
      original.after(footer);
      original.dataset.frMinFooterReady = 'true';

      const revealNewsletterResult = () => {
        if (form?.id && location.hash === `#${form.id}` && !newsletter.open) openNewsletter();
      };
      const onHashChange = () => {
        if (footer.isConnected) revealNewsletterResult();
      };
      window.addEventListener('hashchange', onHashChange);
      instances.set(original, () => {
        window.removeEventListener('hashchange', onHashChange);
        for (const dialog of Object.values(dialogs)) if (dialog.open) dialog.close();
      });
      // Shopify redirects the original customer form back to #ContactFooter after submission.
      revealNewsletterResult();
    } catch (error) {
      if (form && newsAnchor?.parentNode) newsAnchor.replaceWith(news);
      if (cookies && cookieAnchor?.parentNode) {
        cookies.textContent = cookieText;
        cookies.className = cookieClass;
        cookieAnchor.replaceWith(cookies);
      }
      delete original.dataset.frMinFooterReady;
      footer.remove();
      console.warn('Frangipani: original footer retained.', error);
    }
  }

  function initialize(scope = document) {
    if (scope.matches?.('footer.footer')) enhance(scope);
    scope.querySelectorAll('footer.footer').forEach(enhance);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('footer.footer').forEach(original => instances.get(original)?.());
  });
})();

/* Card quick add: desktop hover/focus pluses, with recommendations also on mobile. */
(() => {
  if (window.frangipaniRecommendationQuickAdd) return;
  window.frangipaniRecommendationQuickAdd = true;

  const scope = '#MainContent .product-grid > li';
  const routeRoot = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const cartURL = new URL(`${routeRoot}cart`, location.origin).href;
  const locale = document.documentElement.lang || 'pl';
  const currency = window.Shopify?.currency?.active || 'PLN';
  const price = value => new Intl.NumberFormat(locale, {
    style: 'currency', currency
  }).format(Number(value) / 100);
  const dimensionNumber = new Intl.NumberFormat(locale, { maximumFractionDigits: 3 });
  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const icon = path => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    for (const [name, value] of Object.entries({ viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': '1.3', 'aria-hidden': 'true' })) svg.setAttribute(name, value);
    const line = document.createElementNS(svg.namespaceURI, 'path');
    line.setAttribute('d', path);
    svg.append(line);
    return svg;
  };

  const dialog = el('dialog', 'fr-quick-dialog');
  dialog.setAttribute('aria-labelledby', 'fr-recommendation-quick-add-title');
  const close = el('button', 'fr-quick-close');
  close.type = 'button';
  close.setAttribute('aria-label', frText('quickadd.close'));
  close.append(icon('m6 6 12 12M6 18 18 6'));
  const title = el('h2', '', frText('quickadd.add'));
  title.id = 'fr-recommendation-quick-add-title';
  const content = el('div');
  dialog.append(close, title, content);
  document.body.append(dialog);

  let current = null;
  let serial = 0;
  close.addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    current?.controller.abort();
    serial += 1;
  });
  dialog.addEventListener('cancel', event => {
    if (current?.posting) event.preventDefault();
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog || current?.posting) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });

  function productURL(card) {
    const link = card.querySelector('.fr-card-title-row a[href*="/products/"]') || card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    const url = new URL(link.href, location.href);
    const productPath = url.pathname.match(/\/products\/([^/]+)\/?$/);
    if (url.origin !== location.origin || !productPath) return null;
    url.pathname = new URL(`${routeRoot}products/${productPath[1]}`, location.origin).pathname;
    url.search = '';
    url.hash = '';
    return url;
  }

  function productLink(state, label = frText('quickadd.product_details')) {
    const link = el('a', 'fr-quick-note', label);
    link.href = state.url.href;
    if (state.variant) {
      const url = new URL(link.href);
      url.searchParams.set('variant', state.variant.id);
      link.href = url.href;
    }
    return link;
  }

  function fallback(state, message) {
    if (state !== current || !dialog.open) return;
    content.replaceChildren();
    const note = el('p', '', message);
    note.setAttribute('role', 'status');
    content.append(note, productLink(state, frText('quickadd.go_product')));
  }

  async function get(url, signal, json = false) {
    const response = await fetch(url, {
      credentials: 'same-origin', signal,
      headers: { Accept: json ? 'application/json' : 'text/html' }
    });
    if (!response.ok) throw new Error(frText('quickadd.fetch_error'));
    return json ? response.json() : response.text();
  }

  function readDimensions(html, product) {
    const dimensions = new Map();
    if (!html) return dimensions;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const widget = Array.from(doc.querySelectorAll('fr-product-dimensions[data-reference]'))
      .find(node => String(node.dataset.productId) === String(product.id));
    if (!widget) return dimensions;
    const json = value => { try { return JSON.parse(value); } catch (_) { return null; } };
    const positive = value => Number.isFinite(value) && value > 0;
    const complete = entry => entry && ['height', 'width', 'length'].every(key => positive(entry[key]));
    const normalize = value => String(value || '').trim().replace(/\s+/g, ' ').toLocaleLowerCase(locale);
    let canonical = null;
    // This is the exact JSON source used by the existing dimensions widget.
    // Parse data only; no script or HTML from the product page is executed/inserted.
    for (const script of doc.querySelectorAll('script:not([src])')) {
      const match = script.textContent.match(/\b(?:var|const|let)\s+DIM_SOURCE_BY_SKU\s*=\s*(\{[\s\S]*?\})\s*;/);
      if (match) { canonical = json(match[1]); break; }
    }
    const widgetVariants = json(widget.dataset.variants);
    const names = json(widget.dataset.optionNames);
    const size = Array.isArray(names) ? names.findIndex(name => /^(rozmiar|size|größe|groesse|wielkość)$/iu.test(name)) : -1;
    const finish = Array.isArray(names) ? names.findIndex(name => /kolor|wykończenie|colou?r|finish|farbe|fertigstellung|ausf(?:ü|ue)hrung|oberfl(?:ä|ae)che/iu.test(name)) : -1;
    const source = new DOMParser().parseFromString(widget.dataset.source || '', 'text/html');
    const entries = Array.from(source.querySelectorAll('.fr-product-dimensions-reference tbody tr')).map(row => {
      const cells = Array.from(row.children).map(cell => cell.textContent.trim());
      if (cells.length !== 4) return null;
      const tuple = cells[2].match(/^(\d+(?:[.,]\d+)?)\s*[×x]\s*(\d+(?:[.,]\d+)?)\s*[×x]\s*(\d+(?:[.,]\d+)?)\s*(?:cm)?$/iu);
      if (!tuple) return null;
      // The supplier reference table's verified column order is length × width × height.
      const values = tuple.slice(1).map(value => Number(value.replace(',', '.')));
      return { color: cells[0], label: cells[1], length: values[0], width: values[1], height: values[2] };
    }).filter(complete);
    for (const variant of product.variants) {
      const sourceVariant = Array.isArray(widgetVariants) ? widgetVariants.find(item => String(item.id) === String(variant.id)) : null;
      if (!sourceVariant) continue;
      const record = sourceVariant.sku && canonical?.[sourceVariant.sku];
      if (record && String(record.productId) === String(product.id)) {
        if (complete(record)) dimensions.set(String(variant.id), record);
        continue; // Explicitly missing canonical values must stay missing.
      }
      const matches = entries.filter(entry => (size < 0 || normalize(entry.label) === normalize(optionValue(sourceVariant, size)))
        && (finish < 0 || normalize(entry.color) === normalize(optionValue(sourceVariant, finish))));
      if (matches.length === 1) dimensions.set(String(variant.id), matches[0]);
    }
    return dimensions;
  }

  function dimensionText(state, variants) {
    if (!variants.length) return '';
    const entries = variants.map(variant => state.dimensions?.get(String(variant.id)));
    if (entries.some(entry => !entry)) return '';
    const values = ['height', 'width', 'length'].map(key => {
      const numbers = entries.map(entry => entry[key]);
      if (numbers.some(value => !Number.isFinite(value) || value <= 0)) return '';
      const min = Math.min(...numbers), max = Math.max(...numbers);
      return dimensionNumber.format(min) + (min !== max ? '–' + dimensionNumber.format(max) : '');
    });
    return values.every(Boolean) ? values.join(' × ') + ' cm' : '';
  }

  /* Read the server-rendered form, including controls associated by form="…".
     Parsed HTML is never inserted or executed; only text and form values are used. */
  function readForm(html, product, variant) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const root = Array.from(doc.querySelectorAll('product-info[data-product-id], [data-fr-product-root]'))
      .find(node => String(node.dataset.productId) === String(product.id));
    const form = root?.querySelector('product-form form[action*="/cart/add"], form[action*="/cart/add"]');
    if (!root || !form) throw new Error(frText('quickadd.configure_product'));
    const fields = Array.from(form.elements);
    const id = fields.find(field => field.name === 'id');
    const submit = form.querySelector('[type="submit"][name="add"], [type="submit"]');
    if (String(id?.value) !== String(variant.id)) throw new Error(frText('quickadd.variant_unconfirmed'));
    if (!variant.available || id.disabled || submit?.disabled || submit?.getAttribute('aria-disabled') === 'true') {
      throw new Error(frText('quickadd.variant_unavailable'));
    }
    if (fields.some(field => field.name === 'selling_plan' && !field.disabled)
      || fields.some(field => /^properties\[/.test(field.name) && field.type !== 'hidden' && !field.disabled)
      || fields.some(field => field.required && !field.disabled && field.name !== 'quantity' && field.type !== 'hidden' && !/^(?:options\[|Rozmiar|Kolor|Wykończenie|(?:Size|Colou?r|Finish(?:ing)?|Fertigstellung|Größe|Groesse|Farbe|Ausf(?:ü|ue)hrung|Oberfl(?:ä|ae)che)$)/iu.test(field.name))) {
      throw new Error(frText('quickadd.additional_choice'));
    }
    const data = new FormData(form);
    const quantityInput = fields.find(field => field.name === 'quantity');
    const min = Math.max(1, Number(quantityInput?.getAttribute('min')) || 1);
    const step = Math.max(1, Number(quantityInput?.getAttribute('step')) || 1);
    const quantity = Number(quantityInput?.value) || min;
    const maximum = Number(quantityInput?.getAttribute('max')) || Infinity;
    if (!Number.isInteger(quantity) || quantity < min || quantity > maximum || (quantity - min) % step !== 0) {
      throw new Error(frText('quickadd.required_quantity'));
    }
    data.set('id', String(variant.id));
    data.set('quantity', String(quantity));
    const property = name => String(data.get(`properties[${name}]`) || '').trim();
    const preorder = root.dataset.purchaseMode === 'preorder' || /przedsprzeda/i.test(property('Tryb zakupu'));
    const terms = property('Warunki przedsprzedaży') || root.querySelector('.fr-preorder-card__terms')?.textContent.trim() || '';
    const availability = property('Przewidywana dostępność');
    const payment = property('Sposób płatności');
    if (preorder && (!terms || !payment)) throw new Error(frText('quickadd.check_preorder'));
    return { data, quantity, preorder, terms, availability, payment };
  }

  async function selectVariant(state, variant, initialHTML, autoAdd = false) {
    const selection = ++state.selection;
    state.variant = variant;
    if (state.productLink) {
      const url = new URL(state.url);
      url.searchParams.set('variant', variant.id);
      state.productLink.href = url.href;
    }
    state.ready = null;
    state.add.disabled = true;
    state.message.textContent = frText('quickadd.checking');
    state.message.setAttribute('role', 'status');
    state.conditions.replaceChildren();
    state.options.querySelectorAll('[data-variant-id]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.variantId === String(variant.id)));
    });
    try {
      const url = new URL(state.url);
      url.searchParams.set('variant', variant.id);
      const html = initialHTML || await get(url, state.controller.signal);
      const ready = readForm(html, state.product, variant);
      if (state !== current || selection !== state.selection || !dialog.open) return;
      state.ready = ready;
      state.message.textContent = '';
      if (ready.preorder) {
        state.conditions.append(el('p', '', frText('quickadd.preorder')), el('p', '', ready.terms));
        if (ready.availability && !ready.terms.includes(ready.availability)) state.conditions.append(el('p', '', frText('quickadd.availability', { date: ready.availability })));
        state.conditions.append(el('p', '', frText('quickadd.payment', { payment: ready.payment })));
      }
      state.add.textContent = ready.quantity === 1 ? frText('quickadd.add') : frText('quickadd.add_quantity', { count: ready.quantity });
      state.add.disabled = false;
      if (autoAdd && !ready.preorder && ready.quantity === 1) await add(state);
    } catch (error) {
      if (error.name === 'AbortError' || state !== current || selection !== state.selection) return;
      state.message.textContent = error.message || frText('quickadd.check_variant_error');
      state.message.setAttribute('role', 'alert');
    }
  }

  function nativeCart() {
    return [document.querySelector('cart-notification'), document.querySelector('cart-drawer')]
      .find(cart => typeof cart?.getSectionsToRender === 'function' && typeof cart?.renderContents === 'function');
  }

  function announceUpdate(variant, response, success) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try {
        const result = publish(success ? PUB_SUB_EVENTS.cartUpdate : PUB_SUB_EVENTS.cartError, {
          source: 'fr-recommendation-quick-add', productVariantId: String(variant.id),
          ...(success ? { cartData: response } : { errors: response.description || response.message, message: response.message })
        });
        result?.catch?.(() => {});
      } catch (_) { /* A theme subscriber must not cause a second add request. */ }
    }
  }

  async function add(state) {
    if (state !== current || !state.ready || state.posting) return;
    state.posting = true;
    close.disabled = true;
    state.add.disabled = true;
    state.add.setAttribute('aria-busy', 'true');
    state.options.querySelectorAll('button').forEach(button => { button.disabled = true; });
    state.message.textContent = frText('quickadd.adding');
    state.message.setAttribute('role', 'status');
    const cart = nativeCart();
    const data = new FormData();
    state.ready.data.forEach((value, key) => data.append(key, value));
    let sections = [];
    if (cart) {
      sections = cart.getSectionsToRender().map(section => section.id).slice(0, 5);
      data.set('sections', sections.join(','));
      data.set('sections_url', location.pathname);
      cart.setActiveElement?.(state.trigger);
    }
    let confirmed = false;
    let serverError = '';
    const mutationController = new AbortController();
    const timeout = setTimeout(() => mutationController.abort(), 20000);
    try {
      // One POST only. Never automatically retry an uncertain cart mutation.
      const response = await fetch(new URL(`${routeRoot}cart/add.js`, location.origin), {
        method: 'POST', credentials: 'same-origin', signal: mutationController.signal,
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: data
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        announceUpdate(state.variant, result, false);
        serverError = typeof result.description === 'string' ? result.description : result.message || frText('quickadd.add_error');
        throw new Error(serverError);
      }
      confirmed = true;
      announceUpdate(state.variant, result, true);
      if (cart && sections.every(id => typeof result.sections?.[id] === 'string')) {
        try {
          close.disabled = false;
          dialog.close();
          cart.classList.remove('is-empty');
          cart.renderContents(result);
          return;
        } catch (_) { /* The item is already added: offer the real cart, never repost. */ }
      }
      if (!dialog.open) dialog.showModal();
      content.replaceChildren(el('p', '', frText('quickadd.added')));
      const link = el('a', 'button button--primary', frText('quickadd.go_cart'));
      link.href = cartURL;
      content.append(link);
    } catch (error) {
      // A network/JSON failure may happen after Shopify accepted the item.
      content.replaceChildren(el('p', '', confirmed
        ? frText('quickadd.added_check_cart')
        : frText('quickadd.check_before_retry', { message: serverError || frText('quickadd.add_unconfirmed') })));
      const cartLink = el('a', 'button button--primary', frText('quickadd.check_cart'));
      cartLink.href = cartURL;
      content.append(cartLink, document.createTextNode(' '), productLink(state));
    } finally {
      clearTimeout(timeout);
      state.posting = false;
      close.disabled = false;
    }
  }

  function optionValue(variant, index) {
    return String(variant.options?.[index] ?? variant[`option${index + 1}`] ?? '').trim();
  }

  function optionGroups(product) {
    if (!Array.isArray(product.options)) return [];
    const priority = name => /rozmiar|size|wielkość|größe|groesse/iu.test(name) ? 0 : /kolor|wykończenie|colou?r|finish|farbe|fertigstellung|ausf(?:ü|ue)hrung|oberfl(?:ä|ae)che/iu.test(name) ? 1 : 2;
    return product.options.map((option, index) => {
      const name = typeof option === 'string' ? option : option.name;
      const values = [...new Set(product.variants.map(variant => optionValue(variant, index)))];
      return { name: name || frText('quickadd.option', { number: index + 1 }), index, values };
    }).filter(group => group.values.length > 1 && !group.values.includes(''))
      .sort((a, b) => priority(a.name) - priority(b.name) || a.index - b.index);
  }

  function resetSelection(state) {
    state.selection += 1;
    state.variant = null;
    state.ready = null;
    state.add.disabled = true;
    state.conditions.replaceChildren();
    state.message.textContent = '';
    state.message.setAttribute('role', 'status');
    state.productLink.href = state.url.href;
  }

  function stepTitle(group) {
    if (/rozmiar|size|wielkość|größe|groesse/iu.test(group.name)) return frText('quickadd.choose_size');
    if (/kolor|wykończenie|colou?r|finish|farbe|fertigstellung|ausf(?:ü|ue)hrung|oberfl(?:ä|ae)che/iu.test(group.name)) return frText('quickadd.choose_finish');
    return frText('quickadd.choose_option', { name: group.name });
  }

  function optionStep(state, step, focus = false) {
    state.options.replaceChildren();
    const chosen = el('div', 'fr-quick-chosen');
    state.groups.slice(0, step).forEach((group, index) => {
      const edit = el('button', 'fr-quick-choice-edit', frText('quickadd.edit_choice', { name: group.name, value: state.choices.get(group.index) }));
      edit.type = 'button';
      edit.addEventListener('click', () => {
        if (state.posting) return;
        state.groups.slice(index).forEach(item => state.choices.delete(item.index));
        resetSelection(state);
        optionStep(state, index, true);
      });
      chosen.append(edit);
    });
    if (chosen.childElementCount) state.options.append(chosen);
    const group = state.groups[step];
    if (!group) {
      const matches = state.product.variants.filter(variant => state.groups.every(item => optionValue(variant, item.index) === state.choices.get(item.index)));
      if (matches.length !== 1) {
        fallback(state, frText('quickadd.full_configuration'));
        return;
      }
      const heading = el('h3', 'fr-quick-step-title', frText('quickadd.selected_options'));
      heading.tabIndex = -1;
      state.options.prepend(heading);
      state.options.append(el('p', 'fr-quick-selected-price', price(matches[0].price)));
      if (focus) heading.focus({ preventScroll: true });
      selectVariant(state, matches[0]);
      return;
    }
    const heading = el('h3', 'fr-quick-step-title', stepTitle(group));
    heading.tabIndex = -1;
    state.options.append(el('p', 'fr-quick-step-count', frText('quickadd.step', { step: step + 1, total: state.groups.length })), heading);
    const choices = el('div', 'fr-quick-step-options');
    choices.setAttribute('role', 'group');
    choices.setAttribute('aria-label', heading.textContent);
    const priorGroups = state.groups.slice(0, step);
    for (const value of group.values) {
      const matches = state.product.variants.filter(variant => optionValue(variant, group.index) === value && priorGroups.every(item => optionValue(variant, item.index) === state.choices.get(item.index)));
      // A finish that has no such size is omitted instead of suggesting a false combination.
      if (!matches.length) continue;
      const available = matches.filter(variant => variant.available);
      const prices = [...new Set((available.length ? available : matches).map(variant => Number(variant.price)))];
      const label = available.length ? (prices.length > 1 ? frText('quickadd.from_price', { price: price(Math.min(...prices)) }) : price(Math.min(...prices))) : frText('quickadd.unavailable');
      const button = el('button');
      button.type = 'button';
      button.disabled = !available.length;
      const copy = el('span', 'fr-quick-option-copy');
      copy.append(el('span', 'fr-quick-option-name', value));
      const measurements = dimensionText(state, available.length ? available : matches);
      if (measurements) copy.append(el('small', 'fr-quick-option-dimensions', measurements));
      button.append(copy, el('span', 'fr-quick-option-price', label));
      button.addEventListener('click', () => {
        if (state.posting || state !== current) return;
        state.groups.slice(step).forEach(item => state.choices.delete(item.index));
        state.choices.set(group.index, value);
        resetSelection(state);
        optionStep(state, step + 1, true);
      });
      choices.append(button);
    }
    state.options.append(choices);
    if (choices.querySelector('.fr-quick-option-dimensions')) state.options.append(el('p', 'fr-quick-dimensions-key', frText('quickadd.dimensions_key')));
    if (focus) heading.focus({ preventScroll: true });
  }

  function variantList(state) {
    state.product.variants.forEach(variant => {
      const button = el('button');
      button.type = 'button';
      button.dataset.variantId = variant.id;
      button.setAttribute('aria-pressed', 'false');
      button.disabled = !variant.available;
      button.append(el('span', '', variant.title === 'Default Title' ? frText('quickadd.one_variant') : variant.title), el('span', '', price(variant.price)));
      if (!variant.available) button.setAttribute('aria-label', frText('quickadd.unavailable_variant', { name: variant.title === 'Default Title' ? frText('quickadd.one_variant') : variant.title }));
      button.addEventListener('click', () => selectVariant(state, variant));
      state.options.append(button);
    });
  }

  async function open(card, trigger) {
    const url = productURL(card);
    if (!url || current?.posting) return;
    current?.controller.abort();
    const token = ++serial;
    const state = { url, trigger, controller: new AbortController(), selection: 0, posting: false };
    current = state;
    title.textContent = frText('quickadd.add');
    content.replaceChildren(el('p', '', frText('quickadd.loading')));
    close.disabled = false;
    if (!dialog.open) dialog.showModal();
    try {
      const [product, productHTML] = await Promise.all([
        get(`${url.href.replace(/\/$/, '')}.js`, state.controller.signal, true),
        get(url, state.controller.signal).catch(() => '')
      ]);
      if (token !== serial || state !== current || !dialog.open) return;
      if (!Array.isArray(product.variants) || !product.variants.length) throw new Error(frText('quickadd.choose_variant_page'));
      state.product = product;
      state.dimensions = readDimensions(productHTML, product);
      title.textContent = product.title;
      if (product.requires_selling_plan || product.selling_plan_groups?.length) {
        fallback(state, frText('quickadd.choose_purchase'));
        return;
      }
      const options = el('div', 'fr-quick-options');
      options.setAttribute('role', 'group');
      options.setAttribute('aria-label', frText('quickadd.choose_variant'));
      state.options = options;
      state.message = el('p', 'fr-quick-note', frText('quickadd.choose_variant_message'));
      state.message.setAttribute('role', 'status');
      state.conditions = el('div', 'fr-quick-preorder');
      state.add = el('button', 'fr-quick-add button button--primary', frText('quickadd.add'));
      state.add.type = 'button';
      state.add.disabled = true;
      state.add.addEventListener('click', () => add(state));
      state.productLink = productLink(state);
      content.replaceChildren(options, state.conditions, state.message, state.add, state.productLink);
      state.groups = optionGroups(product);
      state.choices = new Map();
      if (product.variants.length > 1 && state.groups.length) {
        state.options.classList.add('fr-quick-sequence');
        state.message.textContent = '';
        optionStep(state, 0);
      } else {
        variantList(state);
      }
      if (product.variants.length === 1 && product.variants[0].available) {
        await selectVariant(state, product.variants[0], null, true);
      } else if (!product.variants.some(variant => variant.available)) {
        state.message.textContent = frText('quickadd.product_unavailable');
      }
    } catch (error) {
      if (error.name !== 'AbortError' && token === serial) fallback(state, error.message || frText('quickadd.load_error'));
    }
  }

  function place(card) {
    const picture = card.querySelector('.card__inner');
    const button = card.querySelector('[data-fr-recommendation-quick-add]');
    if (!picture || !button) return;
    const a = picture.getBoundingClientRect(), b = card.getBoundingClientRect();
    button.style.top = `${Math.max(0, a.top - b.top + a.height - 54)}px`;
    button.style.bottom = 'auto';
    button.style.right = `${Math.max(0, b.right - a.right + 10)}px`;
  }
  const positions = new ResizeObserver(entries => {
    entries.forEach(({ target }) => {
      const card = target.closest(scope);
      if (card) place(card);
    });
  });
  const positionTargets = new Set();
  function install() {
    positionTargets.forEach(picture => {
      if (picture.isConnected) return;
      positions.unobserve(picture);
      positionTargets.delete(picture);
    });
    document.querySelectorAll(scope).forEach(card => {
      if (card.querySelector('[data-fr-recommendation-quick-add]') || !productURL(card)) return;
      const picture = card.querySelector('.card__inner');
      if (!picture) return;
      const recommendation = Boolean(card.closest('.related-products'));
      const button = el('button', `fr-card-quick-add ${recommendation ? 'fr-card-quick-add--recommendation' : 'fr-card-quick-add--listing'}`);
      button.type = 'button';
      button.dataset.frRecommendationQuickAdd = '';
      const name = card.querySelector('.card__heading')?.textContent.trim() || frText('quickadd.product');
      button.setAttribute('aria-label', frText('quickadd.add_named', { name }));
      button.setAttribute('aria-haspopup', 'dialog');
      button.append(icon('M5 12h14M12 5v14'));
      button.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        open(card, button);
      });
      if (getComputedStyle(card).position === 'static') card.style.position = 'relative';
      card.classList.add('fr-card-with-quick-add');
      card.append(button);
      positions.observe(picture);
      positionTargets.add(picture);
      place(card);
    });
  }
  install();
  let scheduled = false;
  new MutationObserver(records => {
    if (scheduled || !records.some(record => record.target instanceof Element && (
      record.target.closest('#MainContent .product-grid') || Array.from(record.addedNodes).some(node => node instanceof Element && (node.matches('.product-grid') || node.querySelector('.product-grid')))
    ))) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; install(); });
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', install);
})();

/* Presentation only: native cart forms, line items, totals and checkout are untouched. */
(() => {
  if (window.frangipaniCompactCartInstalled) return;
  window.frangipaniCompactCartInstalled = true;
  const mobile = window.matchMedia('(max-width:749px)');
  const states = new WeakMap();
  const controlSelector = 'input, select, textarea, button, form';
  const propertyName = row => (row.querySelector('dt')?.textContent || '').trim().replace(/:\s*$/, '').toLocaleLowerCase('pl');
  const propertyAliases = { 'purchase type': 'tryb zakupu', 'kaufart': 'tryb zakupu', 'batch': 'partia', 'charge': 'partia', 'pre-order terms': 'warunki przedsprzedaży', 'vorbestellbedingungen': 'warunki przedsprzedaży', 'payment method': 'sposób płatności', 'zahlungsmethode': 'sposób płatności', 'zahlungsart': 'sposób płatności', 'order fulfilment': 'realizacja zamówienia', 'bestellabwicklung': 'realizacja zamówienia' };
  const canonicalPropertyName = row => propertyAliases[propertyName(row)] || propertyName(row);
  const foldedProperties = new Set(['tryb zakupu', 'partia', 'warunki przedsprzedaży', 'sposób płatności', 'realizacja zamówienia']);

  function restoreLine(record) {
    record.rows.forEach(row => {
      if (row.anchor.isConnected && row.node.isConnected) row.anchor.replaceWith(row.node);
    });
    record.wrapper.remove();
  }

  function compactLineItems(state, items) {
    items.querySelectorAll('.cart-item__details').forEach(container => {
      if (state.lineRecords.some(record => record.container === container)) return;
      const lists = Array.from(container.children).filter(node => node.tagName === 'DL');
      const rows = lists.flatMap(list => Array.from(list.children).filter(row => row.matches('.product-option') && row.querySelector('dt') && row.querySelector('dd')));
      const mode = rows.find(row => canonicalPropertyName(row) === 'tryb zakupu')?.querySelector('dd')?.textContent.trim() || '';
      const preorder = /przedsprzeda[żz]|pre[ -]?order|vorbestellung/iu.test(mode) || (mode && !/^standard(?:owy)?$/iu.test(mode) && rows.some(row => canonicalPropertyName(row) === 'warunki przedsprzedaży'));
      if (!preorder) return;
      const toMove = rows.filter(row => foldedProperties.has(canonicalPropertyName(row)) && !row.querySelector(controlSelector));
      if (!toMove.length) return;
      const wrapper = document.createElement('details');
      wrapper.className = 'fr-cart-item-preorder';
      wrapper.innerHTML = '<summary><span>' + frText('preorder_details') + '</span><svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="m5 7 5 5 5-5"/></svg></summary>';
      const content = document.createElement('dl');
      content.className = 'fr-cart-item-preorder__content';
      const moved = toMove.map(node => {
        const anchor = document.createComment('Frangipani original line property position');
        node.before(anchor);
        content.append(node);
        return { node, anchor };
      });
      wrapper.append(content);
      lists[lists.length - 1].after(wrapper);
      state.lineRecords.push({ container, wrapper, rows: moved });
    });
  }

  function restore(record) {
    if (record.anchor.isConnected && record.node.isConnected) record.anchor.replaceWith(record.node);
    if (!record.hadContentClass) record.node.classList.remove('fr-cart-compact-notice__content');
    record.wrapper.remove();
  }

  function moveNotice(state, node, title, blocked, items, form) {
    if (!node || node.querySelector(controlSelector)) return;
    const anchor = document.createComment('Frangipani original cart notice position');
    const wrapper = document.createElement(blocked ? 'div' : 'details');
    wrapper.className = 'fr-cart-compact-notice' + (blocked ? ' fr-cart-compact-notice--warning' : '');
    if (!blocked) {
      const summary = document.createElement('summary');
      const label = document.createElement('span');
      label.textContent = title;
      summary.append(label);
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 20 20');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '1.2');
      svg.setAttribute('aria-hidden', 'true');
      const path = document.createElementNS(svg.namespaceURI, 'path');
      path.setAttribute('d', 'm5 7 5 5 5-5');
      svg.append(path);
      summary.append(svg);
      wrapper.append(summary);
    }
    const hadContentClass = node.classList.contains('fr-cart-compact-notice__content');
    node.before(anchor);
    node.classList.add('fr-cart-compact-notice__content');
    wrapper.append(node);
    // A warning that blocks checkout remains fully visible before the products.
    if (blocked && form) form.before(wrapper);
    else items.append(wrapper);
    state.records.push({ node, anchor, wrapper, hadContentClass });
  }

  function refine(drawer, state) {
    if (!drawer.isConnected) return;
    // Shopify replaces the drawer's inner HTML after each native cart update.
    state.records = state.records.filter(record => {
      if (record.anchor.isConnected && record.node.isConnected && record.wrapper.isConnected) return true;
      record.wrapper.remove();
      return false;
    });
    state.lineRecords = state.lineRecords.filter(record => {
      if (record.container.isConnected && record.wrapper.isConnected && record.rows.every(row => row.anchor.isConnected && row.node.isConnected)) return true;
      record.wrapper.remove();
      return false;
    });
    if (!mobile.matches) {
      state.records.forEach(restore);
      state.records = [];
      state.lineRecords.forEach(restoreLine);
      state.lineRecords = [];
      drawer.classList.remove('fr-cart-compact');
      return;
    }
    drawer.classList.add('fr-cart-compact');
    const inner = drawer.querySelector('#CartDrawer .drawer__inner');
    const footer = inner?.querySelector('.drawer__footer');
    const items = inner?.querySelector('cart-drawer-items');
    const form = items?.querySelector('#CartDrawer-Form');
    if (!footer || !items || !form) return;
    compactLineItems(state, items);
    const checkout = footer.querySelector('#CartDrawer-Checkout');
    const preorder = footer.querySelector('.fr-cart-preorder');
    const blocked = Boolean(preorder && (preorder.querySelector('p strong') || checkout?.disabled || checkout?.getAttribute('aria-disabled') === 'true'));
    moveNotice(state, preorder, frText('preorder_shipping'), blocked, items, form);
    const outlet = footer.querySelector('.fr-cart-outlet, .fr-cart-outlet-note');
    const outletBlocked = Boolean(outlet && (outlet.querySelector('p strong') || checkout?.disabled || checkout?.getAttribute('aria-disabled') === 'true'));
    moveNotice(state, outlet, frText('outlet_product_information'), outletBlocked, items, form);
    moveNotice(state, footer.querySelector('.tax-note'), frText('delivery'), false, items, form);
  }

  function setup(drawer) {
    if (states.has(drawer)) return;
    const state = { records: [], lineRecords: [], queued: false };
    states.set(drawer, state);
    const refresh = () => {
      if (state.queued) return;
      state.queued = true;
      requestAnimationFrame(() => {
        state.queued = false;
        refine(drawer, state);
      });
    };
    new MutationObserver(refresh).observe(drawer, { childList: true, subtree: true });
    refine(drawer, state);
  }
  function initialize() {
    document.querySelectorAll('cart-drawer').forEach(drawer => {
      setup(drawer);
      refine(drawer, states.get(drawer));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  mobile.addEventListener('change', initialize);
})();

/* A short availability note beside the showroom's contact information. */
(() => {
  if (window.frangipaniShowroomNoteInstalled) return;
  if (!/^\/(?:en\/|de\/)?pages\/contact\/?$/.test(location.pathname) || new URLSearchParams(location.search).get('view') !== 'stores') return;
  window.frangipaniShowroomNoteInstalled = true;

  function initialize() {
    document.querySelectorAll('#MainContent .fr-showroom').forEach(showroom => {
      const note = showroom.querySelector('.fr-showroom__consultation');
      if (!note || note.dataset.frCompactNote === 'true') return;
      const contact = note.querySelector('a[href]');
      if (!contact) return;
      const copy = document.createElement('p');
      copy.textContent = frText('showroom_availability');
      // Reuse the real contact link without changing its destination or bindings.
      note.replaceChildren(copy, contact);
      note.dataset.frCompactNote = 'true';
      const visits = showroom.querySelectorAll('.fr-showroom__visit');
      if (visits.length === 1) visits[0].append(note);
      document.documentElement.classList.add('fr-showroom-refined');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

})();
